import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Inject
} from "@angular/core";
import { AuthService } from "src/app/core/services/authentication.service";
import { CargoDetailService } from "./cargo-detail.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarService } from "src/app/core/services/snackBar.service";
import { NgxSpinnerService } from "ngx-spinner";
declare var google: any;
import 'firebase/database';
import 'firebase/storage';
import { Utils } from "src/app/core/resources/utils";
import { AccountService } from "../../account/account.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { GoogleService } from "src/app/core/services/google.service";
import { RegisterCargoPaymentComponent } from "../register-cargo-payment/register-cargo-payment.component";
import { ListCargoPaymentsComponent } from "../list-cargo-payments/list-cargo-payments.component";
import { Cargo } from "src/app/core/interfaces/cargo";
import { User } from "src/app/core/interfaces/user";
import { Company } from "src/app/core/interfaces/company";
import { Titles } from "src/app/core/resources/titles";
import { ModalComponent } from "src/app/shared/modal/modal.component";
import { PermissionRole } from "src/app/core/resources/permission-role";
import { RoleService } from "src/app/core/services/role.service";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { AdminUsersService } from "../../administration/admin-users/admin-users.service";
import { CargoItemService } from "../cargo-item/cargo-item.service";
import { CargoEvidenceComponent } from "../cargo-evidence/cargo-evidence.component";
import { VehiclesService } from "../../administration/vehicles/list-vehicles.service";
import { Vehicle } from "src/app/core/interfaces/vehicle";
import { DateFormatPipe } from "src/app/core/pipe/dateFormat.pipe";
import { Permission } from "src/app/core/resources/permission";
import { OpenImgComponent } from "src/app/shared/open-img/open-img.component";
import ContentTypes from "src/app/core/resources/content-type-ext.json";
import { AdditionalCost } from "src/app/core/interfaces/additionalCost";
import { CargoRatingComponent } from "../cargo-rating/cargo-rating.component";
import { UpdateAdditionalCostCargoComponent } from "./components/update-additional-cost-cargo/update-additional-cost-cargo.component";
import { CargoAdvancePercentageComponent } from "../cargo-advance-percentage/cargo-advance-percentage.component";
import { DriverCargoComponent } from "../driver-cargo/driver-cargo.component";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";
import { FormControl, Validators } from "@angular/forms";
import { ManualCreationCargoService } from "../manual-creation-cargo/manual-creation-cargo.service";
import { CargoEditTypeVehicleComponent } from "../cargo-edit-type-vehicle/cargo-edit-type-vehicle.component";
import { environment } from "src/environments/environment";
import { AdditionalCostsHistoryComponent } from "../additional-costs-history/additional-costs-history.component";
import { AdditionalCostDeleted } from "src/app/core/interfaces/additionalCostDeleted";
import { CompanyNamePipe } from "src/app/core/pipe/companyName.pipe";
import { SiigoManager } from "src/app/core/managers/siigo.manager";
import { ServiceMessages } from "src/app/core/messages/service-messages.enum";
import { finalize, map, take } from "rxjs/operators";
import { combineLatest, Observable, Subscription } from "rxjs";
import { CargoMessages } from "src/app/core/messages/cargo-messages.enum";
import { ModalEnum } from "src/app/core/enums/modal.enum";
import { FirebaseDatabase } from "src/app/core/services/firebaseDatabase.service";
import { CargoTracking } from "src/app/core/interfaces/cargoTracking.interface";
import { CargoManager, VEHICLE_TRIP_VALIDATION_EXCEPTION_CODE } from "src/app/core/managers/cargo.manager";
import { DateManager } from "src/app/core/managers/date.manager";
import { OptionsAutocomplete } from "src/app/core/interfaces/optionsAutocomplete";
import { StandardMapComponent } from "src/app/shared/standard-map/standard-map.component";
import { Global } from "src/app/core/resources/global";
import { UserManager } from "src/app/core/managers/user.manager";
import { Roles } from "src/app/core/enums/roles.enum";
import { CargoShippingCostDialogComponent } from "../cargo-shipping-cost-dialog/cargo-shipping-cost-dialog.component";
import { TransferredPaymentsDialogComponent } from "../transferred-payments-dialog/transferred-payments-dialog.component";
import { Tag } from "src/app/core/interfaces/tag";
import { EndCargoCheckComponent } from "../end-cargo-check/end-cargo-check.component";
import { BasicCompany } from "src/app/core/interfaces/basicCompany";
import { CargoStateDict, CargoStateEnum } from "src/app/core/enums/cargoState.enum";
import { CargoComplimentsComponent } from "../cargo-compliments/cargo-compliments.component";
import { TravelExpensesService } from "src/app/core/services/travel-expenses.service";
import { ApprovalStateEnum, TravelExpense, TravelExpenseDetail } from "src/app/core/interfaces/travel-expense";
import { TravelExpensesComponent } from "../manual-creation-cargo/travel-expenses/travel-expenses.component";
import { LegalizeTravelExpensesComponent } from "../legalize-travel-expenses/legalize-travel-expenses.component";
import { ServiceType } from "src/app/core/interfaces/serviceType";
import { PlanningRoute } from "src/app/core/interfaces/planning-route";
import { PlanningRouteService } from "src/app/core/services/planning-route.service";
import { CargoService } from "src/app/core/services/cargo.service";
import { RiskProfileService } from "src/app/core/services/risk-profile.service";
import { CargoPlanningRouteComponent } from "../cargo-planning-route/cargo-planning-route.component"
import { Fmt } from "src/app/core/messages/fmt";
import { ResourceMessages } from 'src/app/core/messages/resource-messages.enum';
import { ShippingCost } from "src/app/core/enums/shipping-cost.enum";
import { UploadDownloadMapService } from "../manual-creation-cargo/components/upload-download-map/uploadDownloadMap.service";
import { CostCenter } from "src/app/core/interfaces/costCenter";
import { CompaniesService } from "../../administration/companies/list-companies.service";
import { BasicResponse } from "src/app/core/interfaces/basicResponse";
import { AssignCostCenterComponent } from "../../administration/companies/assign-cost-center/assign-cost-center.component";
import { CargoItineraryNearnessIndex } from "src/app/core/interfaces/route-itinerary";
import { Destination } from "src/app/core/interfaces/destination";
import { CargoGuidesListComponent } from "../../guides/cargo-guides-list/cargo-guides-list.component";
import { ConsignmentFormComponent } from "../consignment-form/consignment-form.component";
import { ConsignmentCargo, ConsignmentCargoUpdateRNDC } from "src/app/core/interfaces/consignmentCargo";
import { ThirdPartyConsignmentService } from "../manual-creation-cargo/components/third-party-consignment/third-party-consignment.service";
import { ThirdPartyAddress } from "src/app/core/interfaces/thirdParty";
import { MenuServiceService } from "../../service-request-form/menu-service/menu-service.service";
import { AddressCargo } from "src/app/core/interfaces/addressCargo";
import { LogisticTime } from "src/app/core/interfaces/durationTime";
import { MillisecondsDigitalClockPipe } from "src/app/core/pipe/millisecondsDigitalClock.pipe";
import { ConsignmentDetailField, ConsignmentManager } from "src/app/core/managers/consignment.manager";
import { ServiceValidationManager } from "src/app/core/managers/service-validation.manager";
import { DynamicFirebaseService } from "src/app/core/services/dynamic-firebase.service";
import {
  DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE,
  DOCUMENT_RECREATION_IN_PROGRESS_TITLE,
  isContractorTransportEditionBlockedByBilling,
  isDocumentRecreationInProgress
} from "src/app/core/resources/transport-company-change.utils";
import { transportCompanyListQueryParams } from "src/app/core/resources/transport-company-context.utils";
import { CargoPayment, CargoPaymentDetail } from "src/app/core/interfaces/cargoPayment";
import { CargoPaymentsService } from "src/app/core/services/cargo-payments.service";
import { VehicleInspect } from "src/app/core/interfaces/vehicleInspect";
import { SatelliteLockInspection } from "src/app/core/interfaces/satelliteLockInspection";
import { DialogSatelliteLockComponent } from "src/app/shared/dialog-satellite-lock/dialog-satellite-lock.component";
import { FreightCostFingerprintHistory } from "src/app/core/interfaces/freightCostFingerprintHistory";
import { RndcFulfillManifestFingerprintHistory, RndcFulfillConsignmentFingerprintHistory } from "src/app/core/interfaces/rndcFulfillFingerprintHistory";
import { CargoTrackingService } from "../cargo-tracking/cargo-tracking.service";
import { FingerprintHistory } from "src/app/core/interfaces/fingerprintHistory";
import { CargoRndcSolverService, RndcResolverResult } from "../cargo-tracking/cargo-rndc-solver.service";
import { GeneralConfigService } from "src/app/core/services/general-config.service";
import { Fingerprint } from "src/app/core/interfaces/fingerprint";
import { FingerprintAuthorizedWithoutConsignment } from "src/app/core/interfaces/fingerprintAuthorizedWithoutConsignment";
import { FingerprintAuthorizedWithoutManifest } from "src/app/core/interfaces/fingerprintAuthorizedWithoutManifest";
import { RndcContingencyAlertConfig, EMPTY_RNDC_CONTINGENCY_ALERT, RndcContingencyEntityStatus } from "src/app/core/interfaces/rndcContingencyAlertConfig";
import { SettingId } from 'src/app/core/interfaces/saas-config';

@Component({
  selector: "app-cargo-detail",
  templateUrl: "./cargo-detail.component.html",
  styleUrls: ["./cargo-detail.component.scss"],
  providers: [CargoDetailService, GoogleService, CurrencyPipe, CompanyNamePipe, DateFormatPipe, FirebaseDatabase, SiigoManager, UserManager, DatePipe, MillisecondsDigitalClockPipe, ConsignmentManager],
})
export class CargoDetailComponent implements OnInit {
  @Input() cargoParam: Cargo;
  updateExtraService: boolean = false;
  permission = Permission;
  readonly documentRecreationInProgressMessage = DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE;
  readonly documentRecreationInProgressTitle = DOCUMENT_RECREATION_IN_PROGRESS_TITLE;
  popupActive: string = "";
  routeGoogle: Object;
  cargo: Cargo;
  negotiationValue: FormControl = new FormControl('', Validators.required);
  negotiationRequestValue: FormControl = new FormControl('', Validators.required);
  isNegotiation: boolean = false;
  isNegotiationRequest: boolean = false;
  listActive = "";
  isCollapsedAdvanceInformation = false;
  message: any;
  driver: User;
  secondDriver: User;
  vehicle: Vehicle;
  refFirebaseActive: any;
  pointsHistory: Array<Object>;
  letterRetirement: FormControl = new FormControl();
  @ViewChild(DriverCargoComponent)
  DriverCargoComponent: DriverCargoComponent;
  @ViewChild(AssignCostCenterComponent)
  assignCostCenterComponent: AssignCostCenterComponent;
  @ViewChild("modalRefuseCargo")
  modalRefuseCargo: ElementRef;
  @ViewChild("modalConfirmNegotiationCargo")
  modalConfirmNegotiationCargo: ElementRef;
  @ViewChild("modalConfirmRefuseRequest")
  modalConfirmRefuseRequest: ModalComponent;
  @ViewChild("modalConfirmAcceptRequest")
  modalConfirmAcceptRequest: ModalComponent;
  @ViewChild("modalConfirmAcceptCargo")
  modalConfirmAcceptCargo: ModalComponent;
  @ViewChild("modalNegotiationRequest")
  modalNegotiationRequest: ElementRef;
  @ViewChild("modalRegisterCargoPayment")
  modalRegisterCargoPayment: RegisterCargoPaymentComponent;
  @ViewChild("modalListCargoPayments")
  modalListCargoPayments: ListCargoPaymentsComponent;
  @ViewChild("modalCargoPDF") modalCargoPDF;
  @ViewChild("modalErrorRNDCApproveCargo")
  modalErrorRNDCApproveCargo: ElementRef;
  instanceModalRefuseCargo: NgbModalRef;
  instanceModalNegotiationRequest: NgbModalRef;
  instanceModalConfirmNegotiationCargo: NgbModalRef;
  instanceModalConfirmRefuseRequest: NgbModalRef;
  company: Company;
  branchOfficeName: string = '';
  tags: Tag[] = [];
  cargoTags: string[] = [];
  cargoConsignments: { [key: string]: ConsignmentCargo } = {};
  cargoConsignmentsFields: { [key: string]: ConsignmentDetailField[] } = {};
  cargoConsignmentsAlerts: { [key: string]: string } = {};
  tagControl = new FormControl('');
  zoneControl = new FormControl('', Validators.required);
  isSubCompany: boolean = false;
  isParentCompany: boolean = false;
  cargoPDF: any;
  errorRNDC: string[] = [];
  cargoEdit = {
    seal: "",
    container: "",
  };

  get containerNumbersLabel(): string {
    if (this.cargo && this.cargo.containers && this.cargo.containers.length) {
      return this.cargo.containers.join(', ');
    }
    return this.cargo && this.cargo.container ? this.cargo.container : '';
  }

  isRootNit: boolean = false;
  editEnabled = false;
  additionalCostsDeleted: Array<AdditionalCostDeleted> = [];
  bonusAndDiscountsDeleted: Array<any> = [];
  historyCargoLogisticTimes = { origin: {}, destination: {} };
  freightCostHistory: FreightCostFingerprintHistory[] = [];
  rndcFulfillManifestHistory: RndcFulfillManifestFingerprintHistory;
  rndcFulfillConsignmentHistory: RndcFulfillConsignmentFingerprintHistory;
  planningRouteHistory: FreightCostFingerprintHistory[] = [];
  paymentsDeleted: Array<any> = [];
  transferredPayments: CargoPaymentDetail[] = [];
  cargoAmountEdit = {
    editing: false,
    value: 0
  };
  public listAdditionalService: AdditionalCost[] = [];
  public environment = environment;
  listCompanies: BasicCompany[] = [];
  @ViewChild(StandardMapComponent) standardMapComponent: StandardMapComponent;
  travelExpenses: Array<TravelExpense> = [];
  minUtility: number = ShippingCost.MINIMUN_UTILITY;
  manifestErrors: string[] = [];
  fixer_attempts = 0;
  isRndcSolverRunning = false;
  ownerCompany: Company;
  cargoCreator: User;
  cargoChangesSub: Subscription;
  rndcContingencySub: Subscription;
  rndcContingencyActive: boolean = false;
  formatter: Intl.NumberFormat;
  isListeningCargoChanges: boolean = false;
  dialogSectionRef: MatDialogRef<any> = null;
  dialogFingerprintRef: MatDialogRef<any> = null;
  paymentsHistoryDialogRef: MatDialogRef<CargoShippingCostDialogComponent> = null;
  listenerId: string = '';
  errorsBySection: { [key: string]: string } = {};
  paymentsHistoryRealtime: CargoPaymentDetail[] = [];
  paymentsHistoryToDisplay: CargoPaymentDetail[] = [];
  isLoadingPaymentsHistory: boolean = false;
  private paymentsHistoryCargoIdListener: string = '';
  private paymentsHistorySubscription: Subscription | null = null;
  public paymentsHistoryProcessing: CargoPaymentDetail[] = [];
  public paymentsHistoryFailed: CargoPaymentDetail[] = [];
  public paymentsHistoryDeleted: CargoPaymentDetail[] = [];
  private paymentsHistoryExtraSubscription: Subscription | null = null;
  satelliteLockInspection: SatelliteLockInspection = null;
  authorizedWithoutConsignmentHistory: FingerprintAuthorizedWithoutConsignment[] = [];
  authorizedWithoutManifestHistory: FingerprintAuthorizedWithoutManifest[] = [];

  public balance: number = 0;
  constructor(
    private router: Router,
    private currencyPipe: CurrencyPipe,
    public service: CargoDetailService,
    public authService: AuthService,
    public roleService: RoleService,
    private snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    public utils: Utils,
    public titles: Titles,
    private accountService: AccountService,
    private modalService: NgbModal,
    private googleService: GoogleService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private adminUserService: AdminUsersService,
    public cargoItemService: CargoItemService,
    private vehiclesService: VehiclesService,
    private companyNamePipe: CompanyNamePipe,
    private millisecondsDigitalClockPipe: MillisecondsDigitalClockPipe,
    private dateFormatPipe: DateFormatPipe,
    @Inject(MAT_DIALOG_DATA) public dialogParams: { cargo: Cargo },
    public dialogRef: MatDialogRef<CargoDetailComponent>,
    private permissionRole: PermissionRole,
    public manualCreationCargoService: ManualCreationCargoService,
    private firebaseDatabase: FirebaseDatabase,
    private siigoManager: SiigoManager,
    private userManager: UserManager,
    public global: Global,
    private cargoManager: CargoManager,
    private planningRouteService: PlanningRouteService,
    private thirdPartyConsignmentService: ThirdPartyConsignmentService,
    private cargoService: CargoService,
    private travelExpensesService: TravelExpensesService,
    public uploadDownloadMapService: UploadDownloadMapService,
    public companiesService: CompaniesService,
    private menuService: MenuServiceService,
    private adminUsersService: AdminUsersService,
    public consignmentManager: ConsignmentManager,
    private serviceValidationManager: ServiceValidationManager,
    private generalConfigService: GeneralConfigService,
    private dynamicFirebaseService: DynamicFirebaseService,
    public cargoPaymentsService: CargoPaymentsService,
    private cargoTrackingService: CargoTrackingService,
    private cargoRndcSolverService: CargoRndcSolverService,
    private riskProfileService: RiskProfileService
  ) {
    this.formatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });
    this.company = this.authService && this.authService.getCompany();
    this.isRootNit = this.authService && this.authService.userIsFromRootNit();

    if (
      this.company &&
      this.company.parentCompany &&
      this.company.parentCompany.length
    ) {
      this.isSubCompany = true;
    } else if (
      this.company &&
      this.company.subCompanies &&
      this.company.subCompanies.length
    ) {
      this.isParentCompany = true;
    }
    if (this.dialogParams && this.dialogParams.cargo)
      this.cargoParam = this.dialogParams.cargo;
    this.getTags();
  }

  ngOnInit() {
    this.rndcContingencySub = this.generalConfigService.rndcContingency$.subscribe((value: boolean) => this.rndcContingencyActive = value);
    this.openCargoListener();
    this.listCompanies = this.accountService.listRegisterCompanies();
    if (sessionStorage.getItem("_lastList")) {
      this.listActive = sessionStorage.getItem("_lastList").toString();
      if (sessionStorage.getItem("_lastList") === "loadsInNegotiation") {
        this.validateDataCargoNegotiation();
      }

      if (sessionStorage.getItem("_lastList") === "cargoRequestNegotiation") {
        this.validateDataCargoRequestNegotiation();
      }
    }
    if (sessionStorage.getItem("_lastList") !== "loadsInNegotiation") {
      this.paramsSubscribe();
    }
  }

  private async openCargoListener() {
    let consecutive = null;
    this.listenerId = '';
    if (this.cargoParam && this.cargoParam.consecutive)
      consecutive = this.cargoParam.consecutive;
    else if (this.route.snapshot.params && this.route.snapshot.params.consecutive)
      consecutive = this.route.snapshot.params.consecutive;
    else if (this.authService && this.authService.cargoActive.cargo && this.authService.cargoActive.cargo.consecutive)
      consecutive = this.authService.cargoActive.cargo.consecutive;

    if (!consecutive) return;
    const { active, id, eventEmitter } = await this.cargoService.composeWatchByConsecutive(Number(consecutive));
    this.isListeningCargoChanges = active;
    if (!active) return;
    this.listenerId = id;
    this.cargoChangesSub = eventEmitter.subscribe((cargo: Cargo) => {
      if (!cargo || (cargo && this.cargo && cargo.id !== this.cargo.id)) return;
      if (this.isNecessaryToRedirect(cargo)) return;
      this.closeEditionDialogs();
      this.setCargoDetail(cargo);
      this.setIndividualInfo();
    }, console.error);
  }

  private setIndividualInfo() {
    // To refresh the tags of the load
    if (this.cargo.labels) this.cargoTags = this.cargo.labels;
    // To refresh the additional costs deleted
    this.getAdditionalCostsDeleted();
    // To refresh the bonus and discounts deleted
    this.getBonusAndDiscountsDeleted();
    // To refresh the payments deleted
    this.getPaymentsDeleted();
    // To refresh the transferred payments
    this.getTransferredPayments();
    // To refresh the second driver
    if (this.cargo.secondDriver && !this.utils.isSameCity(this.cargo))
      this.getDetailDriver(this.cargo.secondDriver, null, true);
    else this.secondDriver = null;
    // To refresh the satellite lock inspection
    if (this.isSatelliteLockService && this.cargo.satelliteLockInspection)
      this.getSatelliteLockInspection();
  }

  private isNecessaryToRedirect(cargo: Cargo): boolean {
    if (this.cargoParam) return false;
    const { redirect, path } = this.cargoManager.checkRedirectCargo(cargo, 'detail');
    if (redirect) {
      this.showAlertChangeState(cargo);
      this.router.navigate([path]);
    }
    return redirect;
  }

  private showAlertChangeState(cargo: Cargo) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `El servicio ${cargo.consecutive} ha sido actualizado`,
      iconAlert: true,
      description: `El servicio ha pasado al estado de ${CargoStateDict[cargo.state] ? CargoStateDict[cargo.state].toLowerCase() : cargo.state}, se te redirigirá a la visual correspondiente`,
      hideBtnCancel: false,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  private closeEditionDialogs() {
    if (this.dialogSectionRef || this.dialogFingerprintRef) this.snackBarService.openSnackBar("El servicio fue actualizado", undefined, 'info');
    if (this.dialogSectionRef) this.dialogSectionRef.close();
    if (this.dialogFingerprintRef) this.dialogFingerprintRef.close();
  }

  private paramsSubscribe() {
    const params = this.route.snapshot.params;
    if (!this.utils.objIsEmpty(params)) {
      if (this.utils.isDefined(params.consecutive)) {
        this.checkTypeOfService(params.consecutive.toString());
      } else {
        this.snackBarService.openSnackBar(
          "Ocurrió un error intentando traer el detalle",
          undefined,
          "error"
        );
        this.goToList();
      }
    } else if (this.utils.isDefined(this.cargoParam))
      this.setCargoDetail(this.cargoParam);
    else if (this.utils.isDefined(this.authService.cargoActive.cargo))
      this.setCargoDetail(this.authService.cargoActive.cargo);
    else {
      this.snackBarService.openSnackBar(
        "Ocurrió un error intentando traer el detalle",
        undefined,
        "error"
      );
      this.goToList();
    }
  }

  validateDataCargoNegotiation() {
    if (this.authService && this.authService.cargoActive.cargo) {
      this.isNegotiation = true;
      if (!this.isListeningCargoChanges)
        this.setCargoDetail(this.authService.cargoActive.cargo);
    } else {
      this.isNegotiation = false;
      this.cargo = null;
      this.snackBarService.openSnackBar(
        "Ocurrió un error intentando traer el detalle"
      );
      this.goToList();
    }

    if (this.authService && !this.authService.cargoActive.cargo) {
      this.goToList();
    }
  }

  validateDataCargoRequestNegotiation() {
    if (this.authService && this.authService.cargoActive.cargo) {
      this.isNegotiationRequest = true;
      if (!this.isListeningCargoChanges)
        this.setCargoDetail(this.authService.cargoActive.cargo);
    } else {
      this.isNegotiationRequest = false;
      this.cargo = null;
      this.snackBarService.openSnackBar(
        "Ocurrió un error intentando traer el detalle"
      );
      this.goToList();
    }

    if (this.authService && !this.authService.cargoActive.cargo) {
      this.goToList();
    }
  }

  getListName() {
    let listName = "";
    switch (this.listActive) {
      case "loadingRoutes":
        listName = "servicios en ruta";
        break;
      case "scheduledLoads":
        listName = "servicios programados";
        break;
      case "loadsInNegotiation":
        listName = "servicios en negociación";
        break;
      case "loadsFinished":
        listName = "servicios terminados";
        break;
      case "expired":
        listName = "servicios vencidos";
        break;
      case "deleted":
        listName = "servicios eliminados";
        break;
      case "approvePayments":
        listName = "aprobación de pagos";
        break;
      case "rndcFulfillments":
        listName = "cumplidos RNDC";
        break;
      case "paymentAdvanceCargo":
      case "paymentExtraAdvanceCargo":
      case "paymentAdditionalCostsCargo":
      case "paymentBalanceCargo":
        listName = "pagos";
        break;
      case "charges":
        listName = "cobros pendientes";
        break;
      case "request":
        listName = "Solicitudes";
        break;
      case "cargoRequestNegotiation":
        listName = "Negociación B2B";
        break;
      case "serviceRequests":
        listName = "Solicitudes de servicio";
        break;
    }
    return listName;
  }

  async setCargoDetail(cargoDetail: Cargo) {
    if (this.isNecessaryToRedirect(cargoDetail)) return;
    this.cargo = cargoDetail;
    this.syncRiskProfileOverrideControl();
    this.getTransferredPayments();
    this.updatePaymentsHistoryToDisplay();
    this.listenPaymentsHistoryRealtime();
    this.loadFingerprintHistories();
    // Load manifest history regardless of retransmission state, so the alert can show in green
    if (this.cargo.ministry && this.cargo.authorizedWithoutManifest)
      this.loadAuthorizedWithoutManifestHistory();
    if (this.canAccessTravelExpenses) this.getTravelExpensesAndUpdateBalance();
    this.updateBalance();
    this.buildHistoryCargoLogisticTimes();
    this.getBranchOffice();
    this.letterRetirement.setValue(this.cargo && this.cargo.cargoModel && this.cargo.cargoModel.tripType && this.cargo.cargoModel.tripType.letterRetirement ? this.cargo.cargoModel.tripType.letterRetirement : null);

    this.cargoEdit.container = this.cargo.container;
    this.cargoEdit.seal = this.cargo.seal;

    if (this.cargo.driver)
      this.getDetailDriver(this.cargo.driver);
    if (this.cargo.secondDriver && !this.utils.isSameCity(this.cargo))
      this.getDetailDriver(this.cargo.secondDriver, null, true);

    if (this.cargo.numberDocumentCreatorLoad && !this.cargoCreator)
      this.getDetailUserClientByDocument(this.cargo.numberDocumentCreatorLoad);
    if (this.cargo.idCompany) this.getOwnerCompany();
    if (this.cargo.labels && this.cargo.labels.length) this.cargoTags = this.cargo.labels;
    if (this.cargo.zone)
      this.zoneControl.setValue(this.cargo.zone);
    // tslint:disable-next-line: radix
    if (this.cargo.distancy && parseInt(this.cargo.distancy.toString()) === 0)
      this.calculateDistanceCargo(this.cargo);
    this.errorsBySection = {};
    if (this.cargo.licensePlate)
      await this.getDetailVehicle(this.cargo.licensePlate);
    if (this.cargo.ministry)
      await this.getCargoConsignments(cargoDetail.id, 'Created');
    // Load consignment history regardless of retransmission state, so the alert can show in green
    if (this.cargo.ministry && Object.values(this.cargoConsignments).some(consignment => consignment && consignment.authorizedWithoutConsignment))
      this.loadAuthorizedWithoutConsignmentHistory();
    if (this.isSatelliteLockService && this.cargo.satelliteLockInspection)
      this.getSatelliteLockInspection();
    this.loadSectionErrors();
    if (this.cargo.manifestError && this.cargo.manifestError.error && !this.rndcContingencyActive)
      this.processManifestErrors(this.cargo.manifestError.error);
    else this.manifestErrors = [];
  }

  get canAccessTravelExpenses(): boolean {
    return this.authService.hasCompanySettingEnabled(SettingId.USE_TRAVEL_EXPENSES);
  }

  private getTravelExpensesAndUpdateBalance() {
    this.travelExpensesService.byCargoId(this.cargo.id).pipe(finalize(() => this.updateBalance())).subscribe(
      (expenses: Array<TravelExpense>) => {
        this.travelExpenses = expenses && expenses.length ? expenses : [];
      }, () => this.travelExpenses = []
    );
  }

  onRefreshCargo($event) {
    this.checkTypeOfService($event);
  }

  /**
   * Opciones de perfil de riesgo para el override manual de Seguridad, segun la config del tenant.
   * Siempre incluye el perfil actual del cargo aunque `availableProfiles` no lo ofrezca (config
   * cacheada en la sesion desactualizada frente a lo que el backend ya calculo, o un umbral que
   * se quito despues de clasificar este servicio): sin esto, el mat-select no encuentra opcion
   * que matchee el valor seleccionado y muestra "Sin definir" pese a que el cargo si tiene perfil.
   */
  get riskProfiles() {
    const available = this.riskProfileService.availableProfiles;
    const current = this.cargo && this.cargo.riskProfile;
    if (current && current.id && !available.some(profile => profile.id === current.id)) {
      return [...available, current];
    }
    return available;
  }

  /** Clase de color segun el nivel de riesgo (para chips y puntos de color). */
  riskClassByName(name: string): string {
    const value = (name || '').toLowerCase();
    if (value.indexOf('alto') >= 0) return 'risk--high';
    if (value.indexOf('medio') >= 0) return 'risk--medium';
    if (value.indexOf('bajo') >= 0) return 'risk--low';
    return 'risk--none';
  }

  /** Clase de color del perfil de riesgo actual del servicio. */
  get riskProfileClass(): string {
    return this.riskClassByName(this.cargo && this.cargo.riskProfile ? this.cargo.riskProfile.name : '');
  }

  /** True si el usuario (equipo de Seguridad) puede sobrescribir manualmente el perfil de riesgo. */
  get canOverrideRiskProfile(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editRiskProfile);
  }

  /** Control del selector de override: guarda el id del perfil (binding primitivo, robusto). */
  riskProfileOverrideControl: FormControl = new FormControl();

  /** Nombre del perfil de riesgo a partir de su id (para el trigger del selector). */
  riskNameById(id: string): string {
    const found = (this.riskProfiles || []).find(r => r.id === id);
    if (found) return found.name || '';
    return this.cargo && this.cargo.riskProfile && this.cargo.riskProfile.name ? this.cargo.riskProfile.name : '';
  }

  /** Sincroniza el selector de override con el perfil actual del servicio (por id). */
  private syncRiskProfileOverrideControl() {
    this.riskProfileOverrideControl.setValue(this.cargo && this.cargo.riskProfile ? this.cargo.riskProfile.id : null);
  }

  /**
   * Se dispara al elegir un perfil en el selector (solo Seguridad). Pide confirmacion antes de
   * aplicar; si se cancela, revierte la seleccion visual al valor actual.
   */
  async onRiskProfileSelected(riskId: string) {
    if (!riskId || !this.cargo) return;
    if (this.cargo.riskProfile && this.cargo.riskProfile.id === riskId) return;
    const newProfile = (this.riskProfiles || []).find(r => r.id === riskId);
    if (!newProfile) return;
    const confirmed = await this.openRiskProfileConfirm(newProfile);
    if (!confirmed) {
      this.syncRiskProfileOverrideControl();
      return;
    }
    this.overrideRiskProfile(newProfile);
  }

  /** Dialogo de confirmacion (UX clara) antes de sobrescribir el perfil de riesgo manualmente. */
  private async openRiskProfileConfirm(newProfile: { id: string, name?: string }): Promise<boolean> {
    const current = this.cargo && this.cargo.riskProfile && this.cargo.riskProfile.name
      ? this.cargo.riskProfile.name : 'Sin definir';
    // Todo servicio se recalcula salvo que ya tenga un override manual: el aviso de que se desactiva
    // el recalculo aplica tambien a los historicos (autoRiskProfile null), que se autogestionan.
    const isAuto = this.cargo && this.cargo.autoRiskProfile !== false;
    const note = isAuto
      ? 'Este cambio <strong>desactiva el recálculo automático</strong> del perfil para este servicio y quedará registrada tu huella (usuario y fecha).'
      : 'Quedará registrada tu huella (usuario y fecha).';
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Cambiar perfil de riesgo del servicio',
      descriptionHTML: `
        <div style="text-align:center;">
          <p style="margin-bottom:12px;">Vas a cambiar <strong>manualmente</strong> el perfil de riesgo de este servicio:</p>
          <p style="font-size:16px;margin:14px 0;">
            <span style="opacity:.7;">${current}</span>
            <span style="margin:0 10px;">&rarr;</span>
            <strong>${newProfile.name}</strong>
          </p>
          <p style="opacity:.8;">${note}</p>
        </div>`,
      icon: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const result = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    return !!(result && result.state);
  }

  /**
   * Override manual del perfil de riesgo del servicio (solo Seguridad). Congela el valor en
   * backend (autoRiskProfile=false) para que no se recalcule automaticamente. Si ya hay vehiculo
   * asignado, el backend valida que cumpla el minimo de viajes del perfil forzado; si no cumple,
   * bloquea y aqui se muestra el motivo con opcion de continuar (permiso overrideRiskValidation).
   */
  overrideRiskProfile(riskProfile: { id: string, name?: string }, overrideRiskValidation?: boolean) {
    if (!riskProfile || !this.cargo || !this.cargo.id) return;
    if (this.cargo.riskProfile && this.cargo.riskProfile.id === riskProfile.id) return;
    this.spinner.show();
    this.cargoService.overrideRiskProfile(this.cargo.id, riskProfile, overrideRiskValidation).subscribe(
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar("Perfil de riesgo actualizado correctamente");
        // Re-consultar el detalle (igual que las demas secciones) para traer perfil y huella reales.
        if (this.cargo && this.cargo.consecutive) this.getCargoDetailById(this.cargo.consecutive.toString());
      },
      async (error) => {
        this.spinner.hide();
        if (error && error.error && error.error.code === VEHICLE_TRIP_VALIDATION_EXCEPTION_CODE) {
          const { continueAnyway } = await this.cargoManager.showRiskValidationBlockedDialog(error.error.message);
          if (continueAnyway) return this.overrideRiskProfile(riskProfile, true);
        }
        this.syncRiskProfileOverrideControl();
        this.snackBarService.openSnackBar("Ocurrió un error al actualizar el perfil de riesgo", undefined, 'error');
      }
    );
  }

  getCargoDetailById(consecutive: string, callback?: any) {
    this.spinner.show();
    this.service.detailCargoByConsecutive(consecutive).subscribe(
      (data: Cargo) => {
        this.spinner.hide();
        if (data && data.id) {
          if (this.isNecessaryToRedirect(data)) return;
          if (data.manifestError && data.manifestError.error && !this.rndcContingencyActive)
            this.processManifestErrors(data.manifestError.error);
          this.setLoadData(data, callback);
        } else {
          this.cargo = null;
          this.snackBarService.openSnackBar(
            "Ocurrió un error intentando traer el detalle", undefined, 'error'
          );
          this.goToList();
        }
      },
      (error) => {
        this.spinner.hide();
        this.cargo = null;
        this.snackBarService.openSnackBar(
          "Ocurrió un error intentando traer el detalle", undefined, 'error'
        );
        this.goToList();
      }
    );
  }

  private async setLoadData(data: Cargo, callback?: any) {
    this.cargo = data;
    this.syncRiskProfileOverrideControl();
    this.updatePaymentsHistoryToDisplay();
    this.listenPaymentsHistoryRealtime();
    this.loadFingerprintHistories();
    // Load manifest history regardless of retransmission state, so the alert can show in green
    if (this.cargo.ministry && this.cargo.authorizedWithoutManifest)
      this.loadAuthorizedWithoutManifestHistory();
    if (this.canAccessTravelExpenses) this.getTravelExpensesAndUpdateBalance();
    // this.updateBalance();
    this.buildHistoryCargoLogisticTimes();
    this.getBranchOffice();
    this.letterRetirement.setValue(this.cargo && this.cargo.cargoModel && this.cargo.cargoModel.tripType && this.cargo.cargoModel.tripType.letterRetirement ? this.cargo.cargoModel.tripType.letterRetirement : null);
    this.cargoEdit.container = this.cargo.container;
    this.cargoEdit.seal = this.cargo.seal;
    if (data.driver) {
      this.getDetailDriver(data.driver, callback);
    } else {
      this.driver = null;
    }
    if (this.cargo.idCompany) this.getOwnerCompany();
    if (data.secondDriver && !this.utils.isSameCity(data)) this.getDetailDriver(data.secondDriver, callback, true);
    else this.secondDriver = null;
    if (data.numberDocumentCreatorLoad && !this.cargoCreator)
      this.getDetailUserClientByDocument(data.numberDocumentCreatorLoad);
    if (data.labels && data.labels.length)
      this.cargoTags = data.labels;
    // tslint:disable-next-line: radix
    if (data.zone)
      this.zoneControl.setValue(data.zone);
    if (
      this.cargo.distancy &&
      parseInt(this.cargo.distancy.toString()) === 0
    ) {
      this.calculateDistanceCargo(this.cargo);
    }
    this.errorsBySection = {};
    if (data.licensePlate)
      await this.getDetailVehicle(data.licensePlate);
    if (data.ministry)
      await this.getCargoConsignments(data.id, 'Created');
    // Load consignment history regardless of retransmission state, so the alert can show in green
    if (this.cargo.ministry && Object.values(this.cargoConsignments).some(consignment => consignment && consignment.authorizedWithoutConsignment))
      this.loadAuthorizedWithoutConsignmentHistory();
    if (this.isSatelliteLockService && this.cargo.satelliteLockInspection)
      this.getSatelliteLockInspection();
    this.loadSectionErrors();
    if (this.cargo.manifestError && this.cargo.manifestError.error && !this.rndcContingencyActive)
      this.processManifestErrors(this.cargo.manifestError.error);
    else this.manifestErrors = [];
  }

  processManifestErrors(manifestErrors: string) {
    this.manifestErrors = manifestErrors.split('Error').filter(error => error.trim() !== '');
    if (this.cargo && !this.documentRecreationInProgress
      && [CargoStateEnum.CREATED, CargoStateEnum.ACCEPTED, CargoStateEnum.END_SERVICE].includes(this.cargo.state)
      && !this.cargo.manifestAuthorization)
      void this.fixManifestError();
  }

  async fixManifestError() {
    if (this.blockDocumentMutation()) return;
    if (this.isRndcSolverRunning) return;
    if (this.fixer_attempts++ > 2) return;
    const hasUserInteractionError = this.cargoRndcSolverService.hasUserInteractionError(this.cargo);
    if (!hasUserInteractionError) this.spinner.show();
    this.isRndcSolverRunning = true;
    const res = await this.cargoRndcSolverService.fixManifestError(this.cargo);
    this.applyRndcResolverResult(res);
    this.isRndcSolverRunning = false;
    if (!hasUserInteractionError) this.spinner.hide();
  }

  private applyRndcResolverResult(res: RndcResolverResult): Promise<void> {
    switch (res.outcome) {
      case "skipped-no-error":
        return;
      case "show-error-dialog":
        this.showErrorManifest(res.message);
        return;
      case "low-agreed-value-open-dialog":
        this.fixLowAgreedValue();
        return;
      case "rebuild-failed-snackbar":
        this.snackBarService.openSnackBar(
          `Ocurrió un error al generar el manifiesto del servicio (${res.consecutive})`,
          undefined,
          "error"
        );
        return;
      case "done-refresh":
        this.snackBarService.openSnackBar(
          "Se aplicó una solución automática para generar el Manifiesto, por favor verifique nuevamente"
        );
        this.snackBarService.openSnackBar("Manifiesto generado correctamente");
        this.checkTypeOfService(res.consecutive.toString());
        return;
    }
  }

  private fixLowAgreedValue() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Ocurrió un error al generar el manifiesto del servicio ${this.cargo && this.cargo.consecutive ? `: ${this.cargo.consecutive}` : ''}`,
      description: 'El valor pactado del flete es muy bajo, por favor elimine el servicio actual y cree un nuevo servicio con un valor mayor.',
      hideBtnConfirm: true,
      hideBtnCancel: false,
      iconError: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  private async showErrorManifest(messageError: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Ocurrió un error al generar el manifiesto de la carga: ${this.cargo.consecutive}`,
      iconError: true,
      description: messageError,
      labelButton1: 'Cancelar',
      labelButton2: 'Volver a intentar',
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const result = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (result && result.state && result.refuse === "Volver a intentar")
      this.rebuildManifest(messageError);
  }

  private async rebuildManifest(messageError: string) {
    if (this.blockDocumentMutation()) return;
    try {
      await this.cargoTrackingService.rebuildManifest(this.cargo.id).toPromise();
      const cargo: Cargo = await this.cargoTrackingService.detailCargoByConsecutive(this.cargo.consecutive.toString()).toPromise();
      if (!cargo) return this.snackBarService.openSnackBar(`Ocurrió un error al generar el manifiesto del servicio (${this.cargo.consecutive})`, undefined, 'error');
      const cargoManifestError = this.utils.getNestedValue(cargo, 'manifestError.error') as string;
      if (cargoManifestError)
        return this.snackBarService.openSnackBar(messageError.includes(cargoManifestError) ? messageError : cargoManifestError, undefined, 'error');
      this.snackBarService.openSnackBar("Manifiesto generado correctamente");
      this.checkTypeOfService(this.cargo.consecutive.toString());
    } catch (error) {
      this.snackBarService.openSnackBar(`Ocurrió un error al generar el manifiesto del servicio (${this.cargo.consecutive})`, undefined, 'error');
    }
  }

  private getServiceRequestByConsecutive(consecutive: string) {
    const serviceRequestsObserver = {
      next: (data: Cargo) => {
        this.spinner.hide();
        if (data && data.id) {
          if (this.isNecessaryToRedirect(data)) return;
          this.setLoadData(data);
        }
        else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');

      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    };
    this.spinner.show();
    this.service.detailServiceRequestByConsecutive(consecutive).subscribe(serviceRequestsObserver);
  }

  private async getCargoConsignments(id: string, state: string) {
    this.cargoConsignmentsFields = {};
    this.cargoConsignments = {};
    this.cargoConsignmentsAlerts = {};
    let consignments: ConsignmentCargo[] = [];
    try { consignments = await this.service.getCargoConsignments(id, state).toPromise() } catch (error) { }
    if (!consignments || !consignments.length) return;
    consignments.forEach(consignment => this.cargoConsignments[consignment.id] = consignment);
    const { cargoConsignmentsAlerts, cargoConsignmentsFields } = this.service.updateConsignmentFieldsAndAlerts(this.cargo, this.cargoConsignments);
    this.cargoConsignmentsAlerts = cargoConsignmentsAlerts;
    this.cargoConsignmentsFields = cargoConsignmentsFields;
  }

  private checkTypeOfService(consecutive: string) {
    if (this.listActive === "serviceRequests") this.getServiceRequestByConsecutive(consecutive);
    else this.getCargoDetailById(consecutive);
  }

  private getBranchOffice() {
    if (!this.cargo || !this.cargo.cargoOwner || !this.utils.isDefined(this.cargo.cargoOwner.branchOffice) || !this.cargo.cargoOwner.documentNumber)
      return this.branchOfficeName = '';

    this.thirdPartyConsignmentService.getThirdPartiesAddressByCompany(this.cargo.cargoOwner.documentNumber).subscribe(
      (thirdParties: ThirdPartyAddress[]) => {
        if (thirdParties && thirdParties.length) {
          const thirdPartySelected = thirdParties.find(thirdParty => thirdParty && thirdParty.address &&
            thirdParty.address.id === this.cargo.cargoOwner.branchOffice);
          this.branchOfficeName = thirdPartySelected ? thirdPartySelected.address.address : '';
        } else this.branchOfficeName = '';
      }, () => {
        this.branchOfficeName = '';
      })
  }

  get cargoState(): string {
    if (this.cargo)
      return CargoStateDict[this.cargo.state ? this.cargo.state : this.cargo.requestState ? this.cargo.requestState : ''];
    return '';
  }

  private getTags() {
    this.manualCreationCargoService.getLabelTags().subscribe(
      (success) => {
        if (success && success.length) this.tags = success;
      },
      (error) => {
      }
    )
  }

  public selectTag($event) {
    this.tagControl.setValue('');
    const tag: string = $event.value;
    if (!this.cargoTags.includes(tag)) {
      this.cargoTags.push(tag);
      this.service.updateCargoLabels(this.cargo.id, this.cargoTags).subscribe(
        (response) => {
          if (response) {
            this.snackBarService.openSnackBar("Etiqueta agregada correctamente");
          }
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar el proceso",
            undefined,
            "alert"
          );
        }
      );
    }

  }

  public clearTag(index: number) {
    this.cargoTags.splice(index, 1);
    this.service.updateCargoLabels(this.cargo.id, this.cargoTags).subscribe(
      (response) => {
        if (response) {
          this.snackBarService.openSnackBar("Etiqueta eliminada correctamente");
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al realizar el proceso",
          undefined,
          "alert"
        );
      }
    );
  }
  get canEditTags(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editCargoTags);
  }

  openCargoCompliments(indexDestination: number, indexAddress: number) {
    const hasFullEditPermission = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editCargoCompliments);
    const hasPartialEditPermission = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editCargoComplimentRequirements);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
      indexDestination,
      indexAddress
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    if (hasFullEditPermission || hasPartialEditPermission)
      dialogConfig.disableClose = true;
    this.dialog.open(CargoComplimentsComponent, dialogConfig);
  }

  get canCheckCompliments(): boolean {
    if (!this.isTransportService && !this.isEscortedService) return false;
    const hasFullEditPermission = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editCargoCompliments);
    const hasPartialEditPermission = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editCargoComplimentRequirements);
    const hasReadPermission = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readCargoCompliments);
    return (hasFullEditPermission || hasPartialEditPermission || hasReadPermission)
      && this.cargo && [this.cargoStateEnum.END_SERVICE, this.cargoStateEnum.START_SERVICE].includes(this.cargo.state);
  }

  rateCargo() {
    const idSessionCargo = this.authService
      .getUserSession()
      .information.document;
    const numberDocumentCreator = this.cargo.numberDocumentCreatorLoad;
    const companyUser = this.authService.getUserSession().clientCompanyId;

    if (
      idSessionCargo == numberDocumentCreator ||
      companyUser == this.cargo.idCompany
    ) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        cargo: this.cargo,
        enableClose: true
      };
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.autoFocus = false;
      const dialogRef = this.dialog.open(CargoRatingComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((response) => {
        if (response && response.state)
          this.checkTypeOfService(this.cargo.consecutive.toString());
      });
    } else {
      this.snackBarService.openSnackBar(
        "El servicio debe ser calificado por su creador o por su compañia propietaria",
        undefined,
        "alert"
      );
    }
  }

  getDetailDriver(idDriver, callback?: any, secondDriver: boolean = false) {
    this.accountService.validateEntity(1, idDriver).subscribe(
      (data: User) => {
        if (this.utils.isDefined(data)) {
          this[secondDriver ? 'secondDriver' : 'driver'] = this.userManager.sanitizeUser(data, Roles.DRIVER);
          if (callback) {
            callback();
          }
          let storage = AuthService.fStorage;
          if (
            this.utils.isDefined(this[secondDriver ? 'secondDriver' : 'driver']) &&
            this.utils.isDefined(this[secondDriver ? 'secondDriver' : 'driver'].profilePicture)
          ) {
            let pathReference = storage.ref(this[secondDriver ? 'secondDriver' : 'driver'].profilePicture);
            pathReference.getDownloadURL().then(
              (data) => {
                this[secondDriver ? 'secondDriver' : 'driver'].profilePicture = data;
              },
              (error) => {
                this[secondDriver ? 'secondDriver' : 'driver'].profilePicture = "";
              }
            );
          }
        } else {
          this[secondDriver ? 'secondDriver' : 'driver'] = {
            information: {
              document: idDriver,
            },
          };
        }
      },
      (error) => {
        this[secondDriver ? 'secondDriver' : 'driver'] = {
          information: {
            document: idDriver,
          },
        };
      }
    );
  }

  getOwnerCompany() {
    const ownerCompanyObserver = {
      next: (data: Company) => {
        this.spinner.hide();
        if (data && data.companyId) this.ownerCompany = data;
      },
      error: (error) => {
        this.spinner.hide();
        console.error(error);
      }
    }
    this.spinner.show();
    this.accountService.validateEntity(2, this.cargo.idCompany).subscribe(ownerCompanyObserver);
  }

  async getDetailVehicle(licensePlate) {
    try {
      const vehicle = await this.vehiclesService.getVehicleFromOwnCompany(licensePlate).toPromise();
      this.vehicle = vehicle ? vehicle : null;
    } catch (error) {
      this.vehicle = null;
    }
  }

  getDetailUserClientByDocument(document: string) {
    this.adminUsersService.getUsersList("userClient", 1, 4, null, document).subscribe(
      (response) => this.cargoCreator = response && response.length ? response[0] : null,
      () => this.cargoCreator = null
    );
  }
  getUrlImgProfile(dataImg) {
    return (
      "https://firebasestorage.googleapis.com/v0/b/teclogi-2ec2f.appspot.com/o/" +
      dataImg +
      "?alt=media"
    );
  }

  getConsignments(iDestination, iAddress) {
    try {
      return this.cargo.cargoFeature.uploadDownload.destination[
        iDestination
      ].addresses[iAddress].consignments
        .toString()
        .replace(/,/g, " - ");
    } catch (e) {
      return "-";
    }
  }

  async reverseCompliment(destinationIndex: string | number, addressIndex: string | number, consignmentId: string) {
    if (this.blockDocumentMutation()) return;
    const destinationId = this.utils.getNestedValue(this.cargo, `cargoFeature.uploadDownload.destination.${destinationIndex}.id`);
    const addressId = this.utils.getNestedValue(this.cargo, `cargoFeature.uploadDownload.destination.${destinationIndex}.addresses.${addressIndex}.id`);
    const consignments: string[] = this.utils.getNestedValue(this.cargo, `cargoFeature.uploadDownload.destination.${destinationIndex}.addresses.${addressIndex}.consignments`);
    if (consignments === undefined || !consignments || !consignments.length || !consignments.includes(consignmentId))
      return this.snackBarService.openSnackBar(`Ocurrió un error al anular el cumplido inicial de la remesa ${consignmentId}`, undefined, 'error');
    try {
      await this.cargoItemService.reverseCompliment(this.cargo.id, consignmentId, destinationId, addressId).toPromise();
    } catch (error) {
      return this.snackBarService.openSnackBar(`Ocurrió un error al anular el cumplido inicial de la remesa ${consignmentId}`, undefined, 'error');
    }

    this.snackBarService.openSnackBar('Operación exitosa');
    this.onRefreshCargo(this.cargo.consecutive);
  }

  getStateNegotiation(status) {
    let titleStatus = "Esperando respuesta del conductor";
    if (status === "Waiting creator") {
      titleStatus = "Esperando respuesta de cliente";
    } else if (status === "Waiting driver") {
      titleStatus = "Esperando respuesta del conductor";
    } else if (status === "Accepted") {
      titleStatus = "Aceptada";
    }
    return titleStatus;
  }

  getModalElement(modalName: string) {
    switch (modalName) {
      case "modalRefuseCargo":
        this.negotiationValue.setValue("");
        return this.modalRefuseCargo;
      case "modalConfirmNegotiationCargo":
        return this.modalConfirmNegotiationCargo;
      case "modalNegotiationRequest":
        this.negotiationRequestValue.setValue("");
        return this.modalNegotiationRequest;
      case "modalConfirmRefuseRequest":
        return this.modalConfirmRefuseRequest;
    }
  }

  getModalInstance(modalName: string) {
    switch (modalName) {
      case "modalRefuseCargo":
        return this.instanceModalRefuseCargo;
      case "modalConfirmNegotiationCargo":
        return this.instanceModalConfirmNegotiationCargo;
      case "modalNegotiationRequest":
        return this.instanceModalNegotiationRequest;
      case "modalConfirmRefuseRequest":
        return this.instanceModalConfirmRefuseRequest;
    }
  }

  openModal(modalName: string) {
    let optionsModal = {
      centered: true,
    };
    let modalInstance = null;

    switch (modalName) {
      case "modalRefuseCargo":
        modalInstance = this.instanceModalRefuseCargo;
        break;
      case "modalNegotiationRequest":
        modalInstance = this.instanceModalNegotiationRequest;
        break;
      case "modalConfirmRefuseRequest":
        modalInstance = this.instanceModalConfirmRefuseRequest;
        break;
      case "modalConfirmNegotiationCargo":
        optionsModal["backdrop"] = "static";
        optionsModal["keyboard"] = false;
        optionsModal["centered"] = true;
        modalInstance = this.instanceModalConfirmNegotiationCargo;
        break;
    }

    modalInstance = this.modalService.open(
      this.getModalElement(modalName),
      optionsModal
    );
  }

  closeModal(modalName: string) {
    if (this.getModalInstance(modalName)) {
      this.getModalInstance(modalName).close();
    }
  }

  goToList() {
    const paymentCargoList = [
      "paymentAdvanceCargo",
      "paymentExtraAdvanceCargo",
      "paymentAdditionalCostsCargo",
      "paymentBalanceCargo"
    ]
    const queryParams = transportCompanyListQueryParams(this.listActive, this.cargo);
    if (paymentCargoList.includes(this.listActive))
      this.router.navigate(["cargo/list/paymentCargo"], { queryParams });
    else if (this.listActive === "serviceRequests")
      this.router.navigate(["cargo/list/service-requests"]);
    else
      this.router.navigate(["cargo/list/" + this.listActive], { queryParams });

  }

  get canEditPublicationZone(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editPublicationZone);
  }

  acceptCargo() {
    this.spinner.show();
    const params = {
      cargoId: this.cargo.id,
      applicantId: this.authService.cargoActive.negotiation.driver,
    };

    this.service.acceptCargo(params).subscribe(
      (data) => {
        this.spinner.hide();
        if (data) {
          if (data['message']) {
            this.snackBarService.openSnackBar(
              data['message'], undefined, 'error'
            );
            this.closeModalAcceptCargo();
          } else {
            this.snackBarService.openSnackBar("Su servicio fue negociado");
            this.authService.cargoActive.negotiation = {
              state: null,
              driver: null,
              negotiatedValueCreator: null,
              negotiatedValueDriver: null,
            };
            this.isNegotiation = false;
            this.closeModalAcceptCargo();
            this.goToList();
          }

        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar el proceso", undefined, 'error'
          );
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al realizar el proceso", undefined, 'error'
        );
      }
    );
  }

  onConfirmAcceptCargo() {
    this.acceptCargo();
  }

  get isRequest(): boolean {
    return this.isNegotiationRequest && this.listActive === 'cargoRequestNegotiation' && this.isParentCompany && this.authService &&
      this.getStateNegotiation(this.authService.cargoActive.negotiationRequest.state) !== 'Aceptada';
  }

  get isOffer(): boolean {
    return this.isNegotiation && this.authService && this.getStateNegotiation(this.authService.cargoActive.negotiation.state) !== 'Aceptada'
      && this.cargo.cargoFeature.productType.type !== 'FixedCargo';
  }

  acceptOffer() {
    this.isRequest ? this.openModalAcceptRequest() : this.openModalAcceptCargo();
  }

  rejectOffer() {
    this.isRequest ? this.openModalRefuseRequest() : this.openModal('modalRefuseCargo');
  }

  openModalAcceptCargo() {
    this.modalConfirmAcceptCargo.openConfirm();
  }

  closeModalAcceptCargo() {
    this.modalConfirmAcceptCargo.closeModal();
  }

  negotiateCargo() {
    if (this.negotiationValue.valid) {
      this.spinner.show();
      const params = {
        idCargo: this.cargo.id,
        idUser: this.authService.cargoActive.negotiation.driver,
        negotiatedValueCreator: this.negotiationValue.value,
      };

      this.service.negotiationCargo(params).subscribe(
        (data) => {
          this.spinner.hide();
          if (data && data["id"] === "200") {
            this.closeModal("modalRefuseCargo");
            this.openModal("modalConfirmNegotiationCargo");
          } else {
            this.snackBarService.openSnackBar("Ocurrió un error al realizar el proceso", undefined, 'alert');
          }
        },
        (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar("Ocurrió un error al realizar el proceso", undefined, 'error');
        }
      );
    } else {
      this.snackBarService.openSnackBar("Debe ingresar un valor valido", undefined, 'alert');
    }
  }

  negotiateRequest() {
    if (this.negotiationRequestValue.valid) {
      this.spinner.show();
      const params = {
        cargoId: this.cargo.id,
        companyId: this.authService.getUserSession().clientCompanyId,
        initialValue: this.cargo.shippingCost.totalCost,
        companyNegotiatedValue: this.negotiationRequestValue.value,
        creatorId: this.cargo.idCompany,
      };

      this.service.negotiationRequest("Negotiate", params).subscribe(
        (data) => {
          this.spinner.hide();
          // if (data && data['id'] === '200') {
          //   this.snackBarService.openSnackBar('Debe ingresar un valor valido', undefined, 'alert');
          // } else {
          this.closeModal("modalNegotiationRequest");
          this.snackBarService.openSnackBar("Tu contraoferta ha sido enviada");
          this.goToList();
          // }
        },
        (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar("Ocurrió un error al realizar el proceso", undefined, 'error');
        }
      );
    } else {
      this.snackBarService.openSnackBar("Debe ingresar un valor valido", undefined, 'alert');
    }
  }

  refuseRequest() {
    this.spinner.show();
    const params = {
      cargoId: this.cargo.id,
      companyId: this.isParentCompany
        ? this.authService.cargoActive.negotiationRequest.companyId
        : this.authService.getUserSession().clientCompanyId,
    };

    this.service.negotiationRequest("Refuse", params).subscribe(
      (data) => {
        this.spinner.hide();
        if (data) {
          this.snackBarService.openSnackBar(
            "Se rechazó la oferta correctamente"
          );
          this.goToList();
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar el proceso"
          );
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al realizar el proceso"
        );
      }
    );
  }

  onConfirmRefuseRequest() {
    this.refuseRequest();
  }

  openModalRefuseRequest() {
    this.modalConfirmRefuseRequest.openConfirm();
  }

  closeModalRefuseRequest() {
    this.modalConfirmRefuseRequest.closeModal();
  }

  acceptRequest() {
    this.spinner.show();
    const params = {
      cargoId: this.cargo.id,
      companyId: this.isParentCompany
        ? this.authService.cargoActive.negotiationRequest.companyId
        : this.authService.getUserSession().clientCompanyId,
    };

    this.service.negotiationRequest("Accepted", params).subscribe(
      (data) => {
        this.spinner.hide();
        if (data) {
          this.snackBarService.openSnackBar("El servicio fue aceptado");
          this.closeModalAcceptRequest();
          this.goToList();
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar el proceso"
          );
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al realizar el proceso"
        );
      }
    );
  }

  onConfirmAcceptRequest() {
    this.acceptRequest();
  }

  openModalAcceptRequest() {
    this.modalConfirmAcceptRequest.openConfirm();
  }

  closeModalAcceptRequest() {
    this.modalConfirmAcceptRequest.closeModal();
  }

  closeModalConfirmNegotiation() {
    this.closeModal("modalConfirmNegotiationCargo");
    // this.modalConfirmNegotiationCargo['hide']();
    this.goToList();
  }

  refuseCargo() {
    this.spinner.show();
    const params = {
      idCargo: this.cargo.id,
      idUser: this.authService.cargoActive.negotiation.driver,
    };

    this.service.refuseCargo(params).subscribe(
      (data) => {
        this.spinner.hide();
        if (data) {
          this.closeModal("modalRefuseCargo");
          this.snackBarService.openSnackBar(
            "Se rechazó la oferta correctamente"
          );
          this.goToList();
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar el proceso"
          );
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al realizar el proceso"
        );
      }
    );
  }

  private openDialogManifestBlocksDissociation(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'No se puede desasociar el vehículo',
      description: 'Este servicio cuenta con un manifiesto generado. Es necesario anular el manifiesto antes de desasociar el vehículo.',
      hideBtnCancel: true,
      iconError: true,
    };
    dialogConfig.height = 'auto';
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  cancelCargo() {
    const hasGeneratedManifest = this.cargo.ministry && this.cargo.manifestAuthorization && this.cargo.rndcTransmited;
    if (hasGeneratedManifest) {
      this.openDialogManifestBlocksDissociation();
      return;
    }
    this.spinner.show();
    const params = {
      cargoId: this.cargo.id,
      userId: this.cargo.driver,
    };

    this.service.cancelCargo(params).subscribe(
      (data) => {
        this.spinner.hide();
        if (data) {
          this.snackBarService.openSnackBar(
            "El servicio se canceló correctamente"
          );
          this.goToList();
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar el proceso", undefined, 'error'
          );
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al realizar el proceso", undefined, 'error'
        );
      }
    );
  }

  public get canUpdatePlanningRoute(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.routes.module,
      this.permission.routes.editCargoRoutePlanning
    ) && this.cargo.state !== CargoStateEnum.END_SERVICE;
  }

  public get canCheckPlanningRoute(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.routes.module,
      this.permission.routes.accessCargoRoutePlanning
    );
  }

  public get isUrbanService(): boolean {
    return this.utils.isSameCity(this.cargo);
  }

  public async checkPlanningRoute() {
    this.spinner.show();
    const hasPermission = this.permissionRole.hasPermission(this.permission.routes.module, this.permission.routes.assignRouteItineraryUnrestricted);
    const result = await this.planningRouteService.checkPlanningRoute(this.cargo, hasPermission);
    if (result.success) {
      this.snackBarService.openSnackBar(result.message);
      this.checkTypeOfService(this.cargo.consecutive.toString());
    } else {
      this.snackBarService.openSnackBar(result.message, undefined, 'error');
    }
    this.spinner.hide();
  }

  public get hasMonitorStateErrors(): { hasErrors: boolean, errors?: string[] } {
    if (!this.cargo || !this.cargo.monitorState) return { hasErrors: false };
    const stateMessages = {
      loadShipmentResponse: "No se transmitió a Monitor debido a: [description]",
      loadZoneEventResponse: "No se transmitió la llegada al cargue a Monitor debido a: [description]",
      downloadZoneEventResponse: "No se transmitió la llegada al descargue a Monitor debido a: [description]",
      finalizeShipmentResponse: "No se transmitió la finalización de la carga a Monitor debido a: [description]",
      cancelShipmentResponse: "No se transmitió la cancelación de la carga a Monitor debido a: [description]",
    }
    const errors = [];
    for (const state in stateMessages) {
      if (this.cargo.monitorState[state] && this.cargo.monitorState[state].transmited === false)
        errors.push(stateMessages[state].replace("[description]", this.cargo.monitorState[state].description));
    }
    return { hasErrors: errors.length > 0, errors };
  }

  public watchItineraryDetail() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      mode: "detail",
      cargo: this.cargo,
      itineraryId: this.cargo.itineraryId,
      itineraryOverviewPolylines: this.cargo.itineraryOverviewPolylines
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.dialog.open(CargoPlanningRouteComponent, dialogConfig);
  }

  public changeItinerary() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      mode: "edit",
      itineraryId: this.cargo.itineraryId,
      routePlanId: this.cargo.routePlanId,
      cargo: this.cargo
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(CargoPlanningRouteComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((response) => {
      if (response && response.state)
        this.checkTypeOfService(this.cargo.consecutive.toString());
    });
  }

  public calculateDistanceCargo(cargo) {
    this.googleService
      .getRouteDataCargo(cargo)
      .then((success: { cargoDistancy; cargoEstimatedTime }) => {
        this.updateFreightForwarder(
          success.cargoEstimatedTime,
          success.cargoDistancy
        );
      })
      .catch((error) => { });
  }

  updateFreightForwarder(estimatedTime, distancy) {
    const data = {
      id: this.cargo.id,
      estimatedTime,
      distancy,
    };
    this.service.updateFreightForwarder(data).subscribe(
      (success) => {
        this.checkTypeOfService(this.cargo.consecutive.toString());
      },
      (error) => {
        this.cargo.distancy = distancy;
        this.cargo.estimatedTime = estimatedTime;
      }
    );
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy() {
    this.closePaymentsHistoryListener();
    if (this.refFirebaseActive) this.refFirebaseActive.off();
    if (this.listenerId) this.cargoService.stopWatch(this.listenerId);
    this.authService.cargoActive.cargo = null;
    this.authService.cargoActive.negotiation = {
      state: null,
      driver: null,
      negotiatedValueDriver: null,
      negotiatedValueCreator: null,
    };
    if (this.cargoChangesSub) this.cargoChangesSub.unsubscribe();
    if (this.rndcContingencySub) this.rndcContingencySub.unsubscribe();
  }

  openModalRegisterPayment() {
    if (this.modalRegisterCargoPayment) {
      this.modalRegisterCargoPayment.openModal();
    }
  }

  openModalListPayments() {
    if (this.modalListCargoPayments) {
      this.modalListCargoPayments.openModal();
    }
  }

  onRegisterPayment($event) {
    if ($event)
      if (!this.isListeningCargoChanges) this.setCargoDetail($event);
      else
        this.checkTypeOfService(this.cargo.consecutive.toString());

  }

  onCancel($event) { }

  getTitleConfirm(a) { }

  updateDriver($event: { data: User, type: string }) {
    if ($event && $event.data && $event.type) this[$event.type] = this.userManager.sanitizeUser($event.data, Roles.DRIVER)
  }

  updateVehicle($event) {
    this.vehicle = $event;
  }

  dismissAllModals() {
    this.modalService.dismissAll();
  }

  enabledEdit() {
    this.editEnabled = true;
  }

  disableEdit() {
    this.editEnabled = false;
    this.cargoEdit.container = this.cargo.container;
    this.cargoEdit.seal = this.cargo.seal;
  }

  updateContainerAndSeal() {
    this.spinner.show();
    const data = {
      id: this.cargo.id,
      container: this.cargoEdit.container,
      seal: this.cargoEdit.seal,
    };
    this.service.updateFreightForwarder(data).subscribe(
      (success) => {
        this.spinner.hide();
        this.checkTypeOfService(this.cargo.consecutive.toString());
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al guardar los campos",
          undefined,
          "error"
        );
      }
    );
  }

  openHistoryDiscountsAndBonuses(type, category) {
    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    config.data = {
      shippingCostToDisplay: this.service.getHistoryDiscountsAndBonuses(this.cargo, type, category),
      typePayment: 'DiscountsAndBonuses',
      cargo: this.cargo,
      finalRate: this.utils.getNestedValue(this.cargo, 'shippingCost.rate'),
      finalCost: this.cargoItemService.getRealCost(this.cargo, false),
      balance: this.balance
    };
    this.dialog.open(CargoShippingCostDialogComponent, config).afterClosed().subscribe(
      (response) => {
        if (response && response.state) this.checkTypeOfService(this.cargo.consecutive.toString());
      }
    );
  }

  openHistoryPayments(type) {
    if (!this.cargo || !this.cargo.id || this.paymentsHistoryDialogRef) return;
    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.data = {
      shippingCostToDisplay: this.paymentsHistoryToDisplay,
      cargo: this.cargo,
      typePayment: "Payments",
      paymentsByStatus: {
        processing: this.paymentsHistoryProcessing,
        failed: this.paymentsHistoryFailed,
        deleted: this.paymentsHistoryDeleted
      }
    };
    this.paymentsHistoryDialogRef = this.dialog.open(CargoShippingCostDialogComponent, config);
    this.syncPaymentsHistoryDialogState();
    this.paymentsHistoryDialogRef.afterClosed().pipe(take(1)).subscribe(() => {
      this.paymentsHistoryDialogRef = null;
      this.checkTypeOfService(this.cargo.consecutive.toString());
    });
  }

  private async listenPaymentsHistoryRealtime() {
    if (!this.cargo || !this.cargo.id) {
      this.closePaymentsHistoryListener();
      return;
    }
    if (this.paymentsHistorySubscription && this.paymentsHistoryCargoIdListener === this.cargo.id) return;
    this.closePaymentsHistoryListener();
    this.isLoadingPaymentsHistory = true;
    this.paymentsHistoryRealtime = [];
    this.paymentsHistoryProcessing = [];
    this.paymentsHistoryFailed = [];
    this.paymentsHistoryDeleted = [];
    this.updatePaymentsHistoryToDisplay();
    this.syncPaymentsHistoryDialogState();

    this.paymentsHistorySubscription = this.cargoPaymentsService.watchCargoPayments$(this.cargo.id).subscribe(
      (payments) => {
        this.paymentsHistoryRealtime = payments;
        this.isLoadingPaymentsHistory = false;
        this.updatePaymentsHistoryToDisplay();
        this.syncPaymentsHistoryDialogState();
        this.updateBalance();
      },
      (error) => {
        this.isLoadingPaymentsHistory = false;
        this.syncPaymentsHistoryDialogState();
        console.error('No fue posible escuchar el historial de pagos en tiempo real', error);
      }
    );

    this.paymentsHistoryExtraSubscription = this.cargoPaymentsService
      .watchCargoPaymentsGrouped$(this.cargo.id, ['PROCESSING', 'FAILED', 'DELETED'])
      .subscribe(
        (grouped) => {
          this.paymentsHistoryProcessing = grouped['PROCESSING'] || [];
          this.paymentsHistoryFailed = grouped['FAILED'] || [];
          this.paymentsHistoryDeleted = grouped['DELETED'] || [];
          this.syncPaymentsHistoryDialogState();
        },
        (error) => console.error('No fue posible escuchar pagos en procesamiento/fallidos/eliminados', error)
      );

    this.paymentsHistoryCargoIdListener = this.cargo.id;
  }

  private syncPaymentsHistoryDialogState(): void {
    if (!this.paymentsHistoryDialogRef || !this.paymentsHistoryDialogRef.componentInstance) return;
    const showLoading = this.isLoadingPaymentsHistory && !this.paymentsHistoryToDisplay.length;
    this.paymentsHistoryDialogRef.componentInstance.setRealtimePaymentsLoading(showLoading);
    this.paymentsHistoryDialogRef.componentInstance.updateShippingCostToDisplay(this.paymentsHistoryToDisplay as any);
    this.paymentsHistoryDialogRef.componentInstance.updateExtraPaymentsByStatus({
      processing: this.paymentsHistoryProcessing,
      failed: this.paymentsHistoryFailed,
      deleted: this.paymentsHistoryDeleted
    });
  }

  private updatePaymentsHistoryToDisplay(): void {
    const legacyPayments = this.getLegacyPaymentsHistory();
    this.paymentsHistoryToDisplay = this.cargoPaymentsService.mergePayments(legacyPayments, this.paymentsHistoryRealtime);
  }

  private getLegacyPaymentsHistory(): CargoPaymentDetail[] {
    if (!this.cargo) return [];
    const legacyPayments = this.service.getHistoryPaid(this.cargo);
    if (!Array.isArray(legacyPayments)) return [];
    return legacyPayments
      .filter((payment: CargoPayment) => !!payment)
      .map((payment: CargoPayment) => ({
        ...payment,
        date: this.cargoPaymentsService.normalizeDate(payment.date)
      }));
  }

  public getCargoWithMergedPayments(): Cargo {
    return this.cargoPaymentsService.getCargoWithMergedPayments(this.cargo, this.paymentsHistoryRealtime);
  }

  private closePaymentsHistoryListener() {
    if (this.paymentsHistorySubscription) {
      this.paymentsHistorySubscription.unsubscribe();
      this.paymentsHistorySubscription = null;
    }
    if (this.paymentsHistoryExtraSubscription) {
      this.paymentsHistoryExtraSubscription.unsubscribe();
      this.paymentsHistoryExtraSubscription = null;
    }
    this.paymentsHistoryCargoIdListener = '';
    this.paymentsHistoryRealtime = [];
    this.paymentsHistoryProcessing = [];
    this.paymentsHistoryFailed = [];
    this.paymentsHistoryDeleted = [];
    this.isLoadingPaymentsHistory = false;
    this.updatePaymentsHistoryToDisplay();
    this.syncPaymentsHistoryDialogState();
  }

  get showPaymentsHistoryIcon(): boolean {
    return !!(this.cargo && this.cargo.id && this.paymentsHistoryToDisplay.length);
  }

  private getAdditionalCostsDeleted() {
    if (!this.hasAdditionalCostsPermission) return;
    this.service.deletedAdditionalCosts(this.cargo.id).subscribe(
      (response) => this.additionalCostsDeleted = response && response.additionalCostsDeleted ? response.additionalCostsDeleted : [],
      () => this.additionalCostsDeleted = []
    );
  }

  private getBonusAndDiscountsDeleted() {
    if (!this.hasDeletedBonusesAndDiscountsPermission) return;
    this.service.deletedBonusAndDiscounts(this.cargo.id).subscribe(
      (response) => this.bonusAndDiscountsDeleted = response && response.length ? response : [],
      () => this.bonusAndDiscountsDeleted = []
    );
  }

  private getPaymentsDeleted() {
    if (!this.hasDeletedPaymentsPermission) return;
    this.service.deletedPayments(this.cargo.id).subscribe(
      (response) => this.paymentsDeleted = response && response.length ? response : [],
      () => this.paymentsDeleted = []
    );
  }

  private getTransferredPayments() {
    this.cargoService.getCargoPayments(this.cargo.id, 'TRANSFERRED').subscribe(
      (response) => this.transferredPayments = response && response.length ? response : [],
      () => this.transferredPayments = []
    );
  }

  /**
   * Obtiene la inspección del candado satelital asociada al cargo actual
   */
  private getSatelliteLockInspection(): void {
    this.service.getSatelliteLockInspection(this.cargo.id).subscribe(
      (response: SatelliteLockInspection) => this.satelliteLockInspection = response ? response : null,
      () => this.satelliteLockInspection = null
    );
  }

  private async verifyNewSatelliteLockInspection(): Promise<{ canCreate: boolean }> {
    const whoDocument = this.cargo.assignedVehicleFingerPrint
      ? this.cargo.assignedVehicleFingerPrint.userId
      : this.cargo.numberDocumentCreatorLoad;
    if (this.authService && whoDocument === this.authService.getUserSession().information.document)
      return { canCreate: true };

    const who = this.cargo.assignedVehicleFingerPrint
      ? this.cargo.assignedVehicleFingerPrint.userName
      : `el operador que asigno el candado satelital`;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `No se encontro registrada una inspección preoperacional del candado satelital.
      Debes comunicarte con ${who} para solicitar el registro de la inspección.`,
      hideBtnCancel: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
    return { canCreate: false };
  }


  async openSatelliteLockInspectionDetail(): Promise<void> {
    const dialogConfig = new MatDialogConfig();
    if (this.satelliteLockInspection) {
      const isRejectedInspection = this.satelliteLockInspection.approval === false;
      dialogConfig.data = {
        cargo: this.cargo,
        satelliteLock: this.cargo.lock,
        inspection: this.satelliteLockInspection,
        isViewInspection: true,
        canApprove: this.canApproveRejectedInspection && isRejectedInspection,
      };
    } else {
      const { canCreate } = await this.verifyNewSatelliteLockInspection();
      if (!canCreate) return;
      dialogConfig.data = {
        satelliteLock: this.cargo.lock,
        cargo: this.cargo,
        user: (this.authService.getUserSession() && this.authService.getUserSession().information) || null,
        isPreoperationalInspection: true,
      };
    }
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;

    const dialogRef = this.dialog.open(DialogSatelliteLockComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.getSatelliteLockInspection();
      }

    });
  }

  /**
   * Verifica si el usuario tiene permiso para aprobar inspecciones rechazadas
   */
  get canApproveRejectedInspection(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.approveRejectedInspection
    );
  }

  private async loadFingerprintHistories(): Promise<void> {
    if (!this.cargo || !this.cargo.id) return;
    if (this.canOpenHistoryFreightCostChanges())
      this.loadFreightCostHistory();
    if (this.canOpenHistoryPlanningRouteChanges())
      this.loadPlanningRouteHistory();
    if (this.canViewRndcFulfillHistory()) {
      this.loadRndcFulfillManifestHistory();
      this.loadRndcFulfillConsignmentHistory();
    }
  }

  private async loadRndcFulfillManifestHistory(): Promise<void> {
    if (!this.cargo || !this.cargo.id) return;
    let history: RndcFulfillManifestFingerprintHistory[] = [];
    try {
      history = await this.service.getFingerPrintHistory(this.cargo.id, 'rndcFulfillManifest').toPromise();
    } catch (error) { }
    if (history && history.length) {
      const recentHistory = history.sort((a, b) => {
        const dateA = DateManager.stringToDate(a.fingerprint.date);
        const dateB = DateManager.stringToDate(b.fingerprint.date);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return DateManager.isBefore(dateA, dateB, 'seconds') ? -1 : 1;
      })[0];
      this.rndcFulfillManifestHistory = recentHistory ? recentHistory : null;
    }
  }

  public canViewRndcFulfillHistory(): boolean {
    if (!this.cargo || !this.cargo.id) return false;
    if (!this.cargo.ministry) return false;
    if (!this.cargo.manifestAuthorization) return false;
    if (!this.cargo.ministryFulfillment) return false;
    if (![CargoStateEnum.END_SERVICE].includes(this.cargo.state)) return false;
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.viewRndcFulfillManifestConsignmentHistory);
  }

  private async loadRndcFulfillConsignmentHistory(): Promise<void> {
    if (!this.cargo || !this.cargo.id) return;
    let history: RndcFulfillConsignmentFingerprintHistory[] = [];
    try {
      history = await this.service.getFingerPrintHistory(this.cargo.id, 'rndcFulfillConsignment').toPromise();
    } catch (error) { }
    if (history && history.length) {
      const recentHistory = history.sort((a, b) => {
        const dateA = DateManager.stringToDate(a.fingerprint.date);
        const dateB = DateManager.stringToDate(b.fingerprint.date);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return DateManager.isBefore(dateA, dateB, 'seconds') ? -1 : 1;
      })[0];
      this.rndcFulfillConsignmentHistory = recentHistory ? recentHistory : null;
    }
  }

  public isSameRndcFulfillResponsible(): boolean {
    if (!this.rndcFulfillManifestHistory && !this.rndcFulfillConsignmentHistory) return false;
    if (!this.rndcFulfillConsignmentHistory) return true;
    const fingerprintManifest = this.utils.getNestedValue(this.rndcFulfillManifestHistory, 'fingerprint') as Fingerprint;
    const fingerprintConsignment = this.utils.getNestedValue(this.rndcFulfillConsignmentHistory, 'fingerprint') as Fingerprint;
    return this.utils.deepEqual(fingerprintManifest, fingerprintConsignment);
  }

  openHistoryAdditionalCostsDeleted() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      list: this.additionalCostsDeleted,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    this.dialog.open(AdditionalCostsHistoryComponent, dialogConfig);
  }

  openHistoryBonusOrPaymentsDeleted(type: 'bonus' | 'payment') {
    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    config.data = {
      title: type === 'bonus' ? 'Bonificaciones y descuentos eliminados' : 'Pagos eliminados',
      shippingCostToDisplay: type === 'bonus' ? this.bonusAndDiscountsDeleted : this.paymentsDeleted,
      typePayment: type === 'bonus' ? 'DiscountsAndBonusesDeleted' : 'PaymentsDeleted'
    };
    this.dialog.open(CargoShippingCostDialogComponent, config);
  }

  openTransferredPayments() {
    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    config.data = {
      title: 'Pagos transferidos',
      payments: this.transferredPayments
    };
    this.dialog.open(TransferredPaymentsDialogComponent, config);
  }

  public canOpenHistoryFreightCostChanges(): boolean {
    if (!this.cargo || !this.cargo.id) return false;
    if ([CargoStateEnum.REQUEST, CargoStateEnum.DELETED, CargoStateEnum.EXPIRED].includes(this.cargo.state)) return false;
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.viewFreightCostChangeHistory);
  }

  private async loadFreightCostHistory() {
    this.freightCostHistory = [];
    if (!this.cargo || !this.cargo.id) return;
    let history: FreightCostFingerprintHistory[] = [];
    try {
      history = await this.service.getFingerPrintHistory(this.cargo.id, 'changeFreightCost').toPromise();
    } catch (error) { }
    this.freightCostHistory = history && history.length ? history : [];
  }

  private getFreightCostHistoryDescription(history: FreightCostFingerprintHistory[]): string {
    let descriptionHTML = '<small class="my-4">A continuación se muestra el historial de cambios del valor del flete, ordenados desde el más antiguo hasta el más reciente.</small>';
    let indexOfChanges = 1;
    [...history].forEach((historyItem) => {
      const freightCost = this.utils.getNestedValue(historyItem, 'data.newFreightCost') as number;
      if (!this.utils.isDefined(freightCost)) return;
      const fingerprintDate = this.utils.getNestedValue(historyItem, 'fingerprint.date') as string;
      const responsibleName = this.utils.getNestedValue(historyItem, 'fingerprint.userName') as string;
      const responsibleDocument = this.utils.getNestedValue(historyItem, 'fingerprint.userId') as string;
      const formattedDate = fingerprintDate ? DateManager.formatDate(fingerprintDate, 'YYYY-MM-DD HH:mm ZZ', 'DD/MM/YYYY HH:mm a') : '';
      const formattedFreightCost = this.formatter.format(freightCost);
      const previousFreightCost = this.utils.getNestedValue(historyItem, 'data.previousFreightCost') as number;
      const reduction = this.utils.getNestedValue(historyItem, 'data.reduction') as number;
      const formattedPreviousFreightCost = this.utils.isDefined(previousFreightCost) ? this.formatter.format(previousFreightCost) : '';
      const formattedReduction = this.utils.isDefined(reduction) ? this.formatter.format(reduction) : '';
      descriptionHTML += `
        <div class="mt-2">
          <div class="alert alert-info p-2 px-4 mb-2 d-flex justify-content-between flex-wrap">
            <div class="text-bold">${indexOfChanges}° Cambio</div>
            <div>${formattedDate}</div>
          </div>
          <div class="pl-3 mb-2 d-flex flex-column">
            <div class="col-12"><strong class="text-bold">Valor del flete:</strong> ${formattedFreightCost}</div>
            ${formattedPreviousFreightCost ? `<div class="col-12"><strong class="text-bold">Valor anterior:</strong> ${formattedPreviousFreightCost}</div>` : ''}
            ${formattedReduction ? `<div class="col-12"><strong class="text-bold">Reducción:</strong> ${formattedReduction}</div>` : ''}
            ${responsibleName ? `<div class="col-12"><strong class="text-bold">Responsable:</strong> ${responsibleName}${responsibleDocument ? ` (${responsibleDocument})` : ''}</div>` : ''}
          </div>
        </div>
      `;
      indexOfChanges++;
    });
    return descriptionHTML + '<div class="mb-5"></div>';
  }

  public async openHistoryFreightCostChanges() {
    if (!this.cargo || !this.cargo.id) return;
    if (!this.freightCostHistory || this.freightCostHistory.length === 0)
      return this.snackBarService.openSnackBar('No se encontraron cambios registrados para el valor del flete', undefined, 'info');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Historial de cambios',
      descriptionHTML: this.getFreightCostHistoryDescription(this.freightCostHistory),
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  public canOpenHistoryPlanningRouteChanges(): boolean {
    if (!this.cargo || !this.cargo.id) return false;
    if ([CargoStateEnum.REQUEST, CargoStateEnum.DELETED, CargoStateEnum.EXPIRED].includes(this.cargo.state)) return false;
    if (!this.cargo.routePlanId || !this.cargo.itineraryId) return false;
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.viewRoutePlanChangeHistory);
  }

  private async loadAuthorizedWithoutConsignmentHistory() {
    this.authorizedWithoutConsignmentHistory = [];
    if (!this.cargo || !this.cargo.id) return;
    let history: FingerprintAuthorizedWithoutConsignment[] = [];
    try {
      history = await this.service.getFingerPrintHistory(this.cargo.id, "authorizedWithoutConsignment").toPromise();
    } catch (error) { }
    this.authorizedWithoutConsignmentHistory = history && history.length ? history : [];
  }

  private async loadAuthorizedWithoutManifestHistory() {
    this.authorizedWithoutManifestHistory = [];
    if (!this.cargo || !this.cargo.id) return;
    let history: FingerprintAuthorizedWithoutManifest[] = [];
    try {
      history = await this.service.getFingerPrintHistory(this.cargo.id, "authorizedWithoutManifest").toPromise();
    } catch (error) { }
    this.authorizedWithoutManifestHistory = history && history.length ? history : [];
  }

  private getAuthorizedWithoutApprovalDescription(
    approval: FingerprintAuthorizedWithoutConsignment | FingerprintAuthorizedWithoutManifest,
    actionLabel: string
  ): string {
    const fingerprintDate = this.utils.getNestedValue(approval, 'fingerprint.date') as string;
    const responsibleName = this.utils.getNestedValue(approval, 'fingerprint.userName') as string;
    const responsibleDocument = this.utils.getNestedValue(approval, 'fingerprint.userId') as string;
    const description = this.utils.getNestedValue(approval, 'data.description') as string;
    const formattedDate = fingerprintDate
      ? DateManager.formatDate(fingerprintDate, 'YYYY-MM-DD HH:mm ZZ', 'DD/MM/YYYY HH:mm a')
      : '';

    return `
      <div class="approval-detail mt-3">
        <div class="alert alert-warning p-3 mb-3">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <strong class="text-bold">Fecha de aprobación:</strong>
            <span>${formattedDate || 'No disponible'}</span>
          </div>
        </div>
        <div class="approval-info px-3">
          ${responsibleName ? `
            <div class="mb-3">
              <strong class="text-bold">Responsable de la aprobación:</strong>
              <div class="mt-1">${responsibleName}${responsibleDocument ? ` (${responsibleDocument})` : ''}</div>
            </div>
          ` : ''}
          <div class="mb-3">
            <strong class="text-bold">Acción realizada:</strong>
            <div class="mt-1">${actionLabel}</div>
          </div>
          ${description ? `
            <div class="mb-3">
              <strong class="text-bold">Observación:</strong>
              <div class="mt-1">${description}</div>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }

  public getReceivablePaymentDiscountCargoId(): string | null {
    const modifications = this.cargo && this.cargo.shippingCost && this.cargo.shippingCost.modifications;
    if (!Array.isArray(modifications)) return null;
    const discount = modifications.find((modification) => {
      const typeName = modification && modification.typeModification && modification.typeModification.name;
      return modification && modification.type == 1 && !!typeName && /abono a cartera/i.test(typeName);
    });
    const match = discount ? /(\d+)\s*$/.exec(discount.observation || '') : null;
    return match ? match[1] : null;
  }

  public getRndcContingencyAlertConfig(): RndcContingencyAlertConfig {
    const consignmentStatus = this.getConsignmentContingencyStatus();
    const manifestStatus = this.getManifestContingencyStatus();

    if (consignmentStatus === 'none' && manifestStatus === 'none') {
      return EMPTY_RNDC_CONTINGENCY_ALERT;
    }

    const pendingLabels: Array<'Remesa' | 'Manifiesto'> = [];
    const completedLabels: Array<'Remesa' | 'Manifiesto'> = [];

    if (consignmentStatus === 'pending') pendingLabels.push('Remesa');
    else if (consignmentStatus === 'retransmitted') completedLabels.push('Remesa');

    if (manifestStatus === 'pending') pendingLabels.push('Manifiesto');
    else if (manifestStatus === 'retransmitted') completedLabels.push('Manifiesto');

    const isCompleted = pendingLabels.length === 0;
    const creationMode = this.cargo && this.cargo.ministryContingency === true ? 'contingencia' : 'intermitencia';
    const alertContent = isCompleted
      ? this.buildRetransmittedRndcAlertContent(completedLabels)
      : this.buildPendingRndcAlertContent(pendingLabels, creationMode);

    return {
      shouldShow: true,
      alertClass: isCompleted ? 'alert-success' : 'alert-warning',
      iconClass: isCompleted ? 'fa-check-circle' : 'fa-exclamation-triangle',
      title: alertContent.title,
      description: alertContent.description,
    };
  }

  private getConsignmentContingencyStatus(): RndcContingencyEntityStatus {
    const contingencyConsignments = Object.values(this.cargoConsignments || {}).filter(
      consignment => consignment && consignment.authorizedWithoutConsignment
    );
    if (!contingencyConsignments.length) return 'none';
    return contingencyConsignments.some(consignment => !consignment.entryId) ? 'pending' : 'retransmitted';
  }

  private getManifestContingencyStatus(): RndcContingencyEntityStatus {
    if (!this.cargo || !this.cargo.ministry || !this.cargo.authorizedWithoutManifest) return 'none';
    return this.cargo.manifestAuthorization ? 'retransmitted' : 'pending';
  }

  private joinRndcEntityLabels(labels: Array<'Remesa' | 'Manifiesto'>): string {
    if (labels.length === 1) return labels[0];
    return `${labels[0]} y ${labels[1]}`;
  }

  private buildPendingRndcAlertContent(
    labels: Array<'Remesa' | 'Manifiesto'>,
    mode: 'contingencia' | 'intermitencia'
  ): { title: string; description: string } {
    const titleSuffix = this.joinRndcEntityLabels(labels);
    const modePhrase = `una ${mode} del RNDC`;
    const modeLabel = mode.charAt(0).toUpperCase() + mode.slice(1);
    const title = `${modeLabel} RNDC – ${titleSuffix}`;
    const statusLine = 'Pendiente de retransmisión:';

    if (labels.length === 1 && labels[0] === 'Remesa') {
      return {
        title,
        description: `${statusLine} La remesa no pudo emitirse por ${modePhrase}. Retransmítela cuando el servicio esté disponible.`,
      };
    }
    if (labels.length === 1 && labels[0] === 'Manifiesto') {
      return {
        title,
        description: `${statusLine} El manifiesto no pudo emitirse por ${modePhrase}. Retransmítelo cuando el servicio esté disponible.`,
      };
    }
    return {
      title,
      description: `${statusLine} La remesa y el manifiesto no pudieron emitirse por ${modePhrase}. Retransmítelos cuando el servicio esté disponible.`,
    };
  }

  private buildRetransmittedRndcAlertContent(
    labels: Array<'Remesa' | 'Manifiesto'>
  ): { title: string; description: string } {
    const titleSuffix = this.joinRndcEntityLabels(labels);
    const title = `Retransmitido – ${titleSuffix}`;

    if (labels.length === 1 && labels[0] === 'Remesa') {
      return {
        title,
        description: `La remesa fue retransmitida correctamente al RNDC.`,
      };
    }
    if (labels.length === 1 && labels[0] === 'Manifiesto') {
      return {
        title,
        description: `El manifiesto fue retransmitido correctamente al RNDC.`,
      };
    }
    return {
      title,
      description: `La remesa y el manifiesto fueron retransmitidos correctamente al RNDC.`,
    };
  }

  public canOpenRndcContingencyHistory(): boolean {
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.viewRndcApprovalFingerprint)) {
      return false;
    }
    return !!(this.authorizedWithoutConsignmentHistory && this.authorizedWithoutConsignmentHistory.length)
      || !!(this.authorizedWithoutManifestHistory && this.authorizedWithoutManifestHistory.length);
  }

  public openRndcContingencyHistory(): void {
    const mode = this.cargo && this.cargo.ministryContingency === true
      ? 'contingencia'
      : 'intermitencia';
    const modeLabel = mode.charAt(0).toUpperCase() + mode.slice(1);

    if (!this.cargo || !this.cargo.id || !this.canOpenRndcContingencyHistory()) {
      const contextWord = this.cargo ? mode : 'aprobación';
      this.snackBarService.openSnackBar(
        `No se encontró información de aprobación para esta ${contextWord}`,
        undefined,
        'info'
      );
      return;
    }

    const sections: string[] = [];
    if (this.authorizedWithoutConsignmentHistory.length) {
      sections.push(this.buildContingencyHistorySection(
        'Remesa',
        this.getAuthorizedWithoutApprovalDescription(
          this.authorizedWithoutConsignmentHistory[0],
          `Autorización de servicio bajo ${mode} RNDC sin emisión de remesa`
        )
      ));
    }
    if (this.authorizedWithoutManifestHistory.length) {
      sections.push(this.buildContingencyHistorySection(
        'Manifiesto',
        this.getAuthorizedWithoutApprovalDescription(
          this.authorizedWithoutManifestHistory[0],
          `Autorización de servicio bajo ${mode} RNDC sin emisión de manifiesto`
        )
      ));
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Aprobaciones de ${modeLabel} RNDC`,
      descriptionHTML: sections.join(''),
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  private buildContingencyHistorySection(label: string, contentHTML: string): string {
    return `
      <div class="mb-3">
        <h6 class="text-bold border-bottom pb-1 mb-2">${label}</h6>
        ${contentHTML}
      </div>
    `;
  }

  private async loadPlanningRouteHistory() {
    this.planningRouteHistory = [];
    if (!this.cargo || !this.cargo.id) return;
    let history: FingerprintHistory[] = [];
    try {
      history = await this.service.getFingerPrintHistory(this.cargo.id, 'changeRoutePlan').toPromise();
    } catch (error) { }
    this.planningRouteHistory = history && history.length ? history : [];
  }

  private getPlanningRouteActionLabel(historyItem: FingerprintHistory): string {
    const newRoutePlanId = (this.utils.getNestedValue(historyItem, 'data.newRoutePlanId') as string) || '';
    const previousRoutePlanId = (this.utils.getNestedValue(historyItem, 'data.previousRoutePlanId') as string) || '';
    const newItineraryId = (this.utils.getNestedValue(historyItem, 'data.newItineraryId') as string) || '';
    const previousItineraryId = (this.utils.getNestedValue(historyItem, 'data.previousItineraryId') as string) || '';
    if (newRoutePlanId && !previousRoutePlanId) return 'Asignación de plan de ruta';
    if (newRoutePlanId === previousRoutePlanId && newItineraryId !== previousItineraryId) return 'Cambio de itinerario';
    return 'Guardado del mismo itinerario';
  }

  private getPlanningRouteHistoryDescription(history: FingerprintHistory[]): string {
    let descriptionHTML = '<small class="my-4">A continuación se muestra el historial de cambios del plan de ruta, ordenados desde el más antiguo hasta el más reciente.</small>';
    let indexOfChanges = 1;
    [...history].forEach((historyItem) => {
      const fingerprintDate = this.utils.getNestedValue(historyItem, 'fingerprint.date') as string;
      const responsibleName = this.utils.getNestedValue(historyItem, 'fingerprint.userName') as string;
      const responsibleDocument = this.utils.getNestedValue(historyItem, 'fingerprint.userId') as string;
      const action = this.getPlanningRouteActionLabel(historyItem);
      if (!fingerprintDate && !responsibleName && !responsibleDocument) return;
      const formattedDate = fingerprintDate ? DateManager.formatDate(fingerprintDate, 'YYYY-MM-DD HH:mm ZZ', 'DD/MM/YYYY HH:mm a') : '';
      descriptionHTML += `
        <div class="mt-2">
          <div class="alert alert-info p-2 px-4 mb-2 d-flex justify-content-between flex-wrap">
            <div class="text-bold">${indexOfChanges}° Cambio</div>
            <div>${formattedDate}</div>
          </div>
          <div class="pl-3 mb-2 d-flex flex-column">
            ${responsibleName ? `<div class="col-12"><strong class="text-bold">Responsable:</strong> ${responsibleName}${responsibleDocument ? ` (${responsibleDocument})` : ''}</div>` : ''}
            <div class="col-12"><strong class="text-bold">Acción:</strong> ${action}</div>
          </div>
        </div>

      `;
      indexOfChanges++;
    });
    return descriptionHTML + '<div class="mb-5"></div>';
  }

  public async openHistoryPlanningRouteChanges() {
    if (!this.cargo || !this.cargo.id) return;
    if (!this.planningRouteHistory || this.planningRouteHistory.length === 0)
      return this.snackBarService.openSnackBar('No se encontraron cambios registrados para el plan de ruta', undefined, 'info');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Historial de cambios',
      descriptionHTML: this.getPlanningRouteHistoryDescription(this.planningRouteHistory),
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  showEvidence(address, index, typeAddress, parent?) {
    const hasPermissionToUploadEvidences = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.uploadEvidences) ||
      this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.uploadExtraDocumentsCargo) ||
      this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.finishCargo);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.utils.clone(this.cargo),
      index: this.utils.clone(index),
      typeAddress: this.utils.clone(typeAddress),
      address: this.utils.clone(address),
    };
    if (this.utils.isDefined(parent))
      dialogConfig.data.parent = this.utils.clone(parent);
    if (this.utils.isDefined(this.cargo.lock))
      dialogConfig.data.lock = this.utils.clone(this.cargo.lock);
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    if (hasPermissionToUploadEvidences)
      dialogConfig.disableClose = true;
    this.dialog.open(CargoEvidenceComponent, dialogConfig);
  }

  getCargoInvoicePDF() {
    this.spinner.show();
    this.cargoItemService
      .getCargoInvoicePDF(this.cargo.id)
      .toPromise()
      .then((response) => {
        var file = new Blob([response], { type: ContentTypes.pdf });
        var fileURL = URL.createObjectURL(file);
        this.openDocumentExtra(response, fileURL, `Factura ${this.cargo.shippingCost.billId}`);
      })
      .catch(() =>
        this.snackBarService.openSnackBar(
          Fmt.string(ResourceMessages.ERROR_LOAD, 'la factura'),
          undefined,
          "error"
        )
      )
      .finally(() => this.spinner.hide());
  }

  public confirmGenerateJournal() {
    const dialogConfig = new MatDialogConfig();
    const title = `¿Estás seguro que deseas generar los Comprobantes Contables para el servicio ${this.cargo.consecutive}?`;
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.generateJournal();
      }
    });
  }

  public generateJournal(): void {
    this.siigoManager.generateJournal([this.cargo.consecutive])
      .then((response) => {
        this.checkResponseGenerateJournal(response);
      })
      .catch((error) => {
        this.checkResponseGenerateJournal(error);
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  private checkResponseGenerateJournal(data) {
    this.siigoManager.showResponseGenerateJournal(data).then((tryAgain) => {
      if (tryAgain && tryAgain.length)
        this.generateJournal();
      this.checkTypeOfService(this.cargo.consecutive.toString());
    });
  }

  async showAdditionalServiceCargo() {
    if (!this.cargo.additionalCosts || !this.cargo.additionalCosts.length) {
      const result = await this.cargoManager.preventContinueCargosWithBill([this.cargo]);
      if (!result || !result.continueAnyway) return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
      listAdditionalService: this.listAdditionalService,
      listActive: this.listActive
    };
    const width = this.cargo && this.cargo.additionalCosts && this.cargo.additionalCosts.length ? ModalEnum.LARGE_WIDTH : ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = width;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(
      UpdateAdditionalCostCargoComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe(() => {
      this.checkTypeOfService(this.cargo.consecutive.toString());
      this.getAdditionalCostsDeleted();
    });
  }

  get isDialog() {
    return !!(this.dialogParams && this.dialogParams.cargo);
  }

  public openDialogNewAdvancePercentage() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(
      CargoAdvancePercentageComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state)
        this.checkTypeOfService(this.cargo.consecutive.toString());
    });
  }

  public getCargoJournalIdPDF(): void {
    this.spinner.show();
    this.cargoItemService.getCargoJournalPdf(this.cargo.id).toPromise()
      .then((response) => {
        var file = new Blob([response], { type: ContentTypes.pdf });
        var fileURL = URL.createObjectURL(file);
        this.openDocumentExtra(response, fileURL, `Comprobante ${this.cargo.journalId}`);
      })
      .catch(() => this.snackBarService.openSnackBar(Fmt.string(ResourceMessages.ERROR_LOAD, 'el comprobante'), undefined, 'error'))
      .finally(() => this.spinner.hide())
  }

  openDocumentExtra(blob: Blob, url: string, title: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      src: url,
      confirmBtn: "Descargar",
      title,
    };
    dialogConfig.height = "80vh";
    dialogConfig.width = "80vw";
    const dialogRef = this.dialog.open(OpenImgComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.utils.downloadFile(blob, "Factura", ContentTypes.pdf);
      }
    });
  }

  public openVehicle() {
    this.DriverCargoComponent.openDetailVehicle();
  }

  public showInspection() {
    this.DriverCargoComponent.openInspectionVehicle();
  }

  openDialogObservation() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Escribe una observación",
      textArea: true,
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((response) => {
      if (response && response.message && response.message != "") {
        this.addObservation(response.message);
      }
    });
  }
  addObservation(text: string) {
    const observation = {
      field: text,
    };
    this.spinner.show();
    this.service
      .addObservation(observation, this.cargo.id)
      .subscribe(
        (success: any) => {
          if (
            success &&
            success.message === "La observacion fue actualizada con exito"
          ) {
            this.checkTypeOfService(this.cargo.consecutive.toString());
            this.snackBarService.openSnackBar(
              "Se añadió correctamente la observacion",
              undefined,
              "success"
            );
          } else {
            this.snackBarService.openSnackBar(
              "Ocurrio un error al añadir la observación",
              undefined,
              "error"
            );
          }
        },
        (error) => {
          this.snackBarService.openSnackBar(
            "Ocurrio un error al añadir la observación",
            undefined,
            "error"
          );
        }
      )
      .add(() => {
        this.spinner.hide();
      });
  }

  public async editTypeVehicle() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      dialog: true,
      vehicleType: this.utils.isDefined(this.cargo.cargoFeature.vehicleType.name) ? this.cargo.cargoFeature.vehicleType.name : ''
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const modalDialog = this.dialog.open(
      CargoEditTypeVehicleComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.spinner.show();
        let feature = {
          cargoMeasure: this.cargo.cargoFeature.cargoMeasure,
          productType: this.cargo.cargoFeature.productType,
          vehicleType: this.cargo.cargoFeature.vehicleType,
        };
        feature.vehicleType.name = result.vehicleType.name;
        feature.vehicleType.bodyWorkType.name = result.vehicleType.bodyWorkType;
        this.service.updatecargoFeature(this.cargo.id, feature).subscribe(
          (response) => {
            if (response) {
              this.checkTypeOfService(this.cargo.consecutive.toString());
              this.snackBarService.openSnackBar(
                "Tipo de vehiculo actualizado correctamente"
              );
            }
            this.spinner.hide();
          },
          (error) => {
            this.spinner.hide();
            this.snackBarService.openSnackBar(
              "Ocurrió un error al realizar el proceso",
              undefined,
              "alert"
            );
          }
        );
      }
    });
  }

  processCostCenter($event: { costCenter: CostCenter, created: boolean } | null) {
    let assignCostCenter = $event && $event.costCenter ? $event.costCenter : null;
    this.associateCostCenter(assignCostCenter, assignCostCenter ? $event.created : false);
  }
  associateCostCenter(costCenter: CostCenter, created: boolean = false) {
    const costCenterObserver = {
      next: (response: BasicResponse) => {
        this.spinner.hide();
        if (response && response.message && response.message === 'Actualizado') {
          this.service.detailCargo(this.cargo.id).subscribe((cargo: Cargo) => this.cargo = cargo);
          !created && this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.STATE_COST_CENTER, costCenter ? 'asociado' : 'desasociado'), undefined, 'success');
        } else {
          this.snackBarService.openSnackBar("Ocurrió un error al asociar el centro de costo", undefined, 'error');
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error(error);
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    }
    this.spinner.show();
    this.companiesService.assignCostCenterToService(this.cargo.id, costCenter).subscribe(costCenterObserver);

  }

  cleanCostCenterCtrl($event: boolean) {
    if ($event && this.assignCostCenterComponent && this.assignCostCenterComponent.costCenterCtrl) this.assignCostCenterComponent.costCenterCtrl.setValue('');
  }

  get hasFinancialPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showCostCargo
    );
  }

  get hasAdditionalCostsPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.additionalCosts
    )
  }

  get hasDeletedBonusesAndDiscountsPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showDeletedBonusesAndDiscounts
    )
  }

  get hasDeletedPaymentsPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showDeletedPayments
    )
  }

  get isEscortedService(): boolean {
    return this.utils.isEscortedService(this.cargo);
  }
  get isSatelliteLockService(): boolean {
    return this.utils.isSatelliteLockService(this.cargo);
  }
  get isTransportService(): boolean {
    return this.utils.isTransportService(this.cargo);
  }

  /**
   * La empresa de transporte solo se muestra en un servicio de transporte de una
   * SaaS que preste ese tipo de servicio. Gobierna el título de la sección y el
   * campo, para que una SaaS de escolta no lea "y empresa de transporte".
   */
  get showTransportCompanyInfo(): boolean {
    return !!(this.authService && this.authService.hasTransportServicesCompany) && this.isTransportService;
  }

  get haveAdvancePayments(): boolean {
    if (!(this.cargo && this.cargo.shippingCost && this.cargo.shippingCost.advanceState)) return false;
    const payments = this.getCargoWithMergedPayments().shippingCost.payments;
    return !!(payments && payments.length && payments.some((payment: CargoPayment) => payment.type === 'advance'));
  }

  get firebasePath(): boolean {
    let fileNameDecode = '';
    if (this.cargo && this.cargo.cargoModel && this.cargo.cargoModel.tripType && this.cargo.cargoModel.tripType.letterRetirement) {
      const url = decodeURIComponent(this.cargo.cargoModel.tripType.letterRetirement);
      const match = url.match(/\/([^\/]+)\?alt=media/);
      fileNameDecode = match ? match[1] : null;
    }
    return !!fileNameDecode;
  }

  public get canFinalizeCargo(): boolean {
    if (this.cargo) {
      const destinations = this.cargo.cargoFeature.uploadDownload.destination;
      const addresses = destinations[destinations.length - 1].addresses;
      return addresses[addresses.length - 1].state === 'Cargo unloaded';
    }
    return false;
  }

  public canReverseInitialCompliment(addressIndex: number, destinationIndex: number, consignmentId: string): boolean {
    if (this.documentRecreationInProgress) return false;
    if (!this.cargo || !this.cargo.ministry || !this.cargo.manifestAuthorization) return false;
    if (![CargoStateEnum.START_SERVICE, this.cargoStateEnum.END_SERVICE].includes(this.cargo.state)) return false;
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.reverseInitialComplitment)) return false;
    const consignment = this.cargoConsignments[consignmentId];
    if (!consignment || !consignment.entryId) return false;
    const address: AddressCargo = this.utils.getNestedValue(this.cargo, `cargoFeature.uploadDownload.destination.${destinationIndex}.addresses.${addressIndex}`);
    if (!address) return false;
    const approvalInitialConsignment = this.utils.getNestedValue(address, 'approvalInitialConsignment');
    if (this.utils.isDefined(approvalInitialConsignment) && approvalInitialConsignment === false) return false;
    return !this.cargo.ministryFulfillment;
  }

  get isPrincipalCompany(): boolean {
    return !!(this.listCompanies.length && this.company && this.company.companyId && this.listCompanies.some(company => company.nit === this.company.companyId));
  }

  get cargoStateEnum(): typeof CargoStateEnum {
    return CargoStateEnum;
  }

  public belowSicetac(cargo: Cargo) {
    const formatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });
    const min = formatter.format(cargo.minimumApprovedValueSicetac);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.disableClose = true;
    this.service.detailCargoByConsecutive(cargo.consecutive.toString()).subscribe(
      (data: any) => {
        this.spinner.hide();
        cargo = data;
        if (this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.approvedBelowSicetac)) {
          if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
            dialogConfig.data = {
              title: '¿Desea aprobar el flete por debajo del SICETAC?',
              descriptionHTML: `El flete mínimo permitido por SICETAC es de <strong>${min}</strong>, si desea ajustarlo por favor realice una bonificación para ajustarse al valor mínimo permitido.`,
              btnDetailCargo: true,
              path: cargo.state === CargoStateEnum.REQUEST
                ? `service-request-form/menu-service/${cargo.consecutive}`
                : `cargo/detail/${cargo.consecutive}`,
            };
            const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(result => {
              if (result && result.state) {
                this.manualCreationCargoService.approvedBelowSiceTac(cargo.id).subscribe(
                  () => {
                    this.openConfirmBelowSicetac();
                  },
                  (error) => {
                    this.snackBarService.openSnackBar("No se pudo aprobar", undefined, 'error');
                  }
                );
              }
            })
          }
        } else {
          if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
            this.snackBarService.openSnackBar(`El flete mínimo es ${min}, por favor realice una bonificación para ajustarse al valor mínimo permitido`, undefined, 'alert');
          }
        }
      })
  }

  openConfirmBelowSicetac() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `Aprobación exitosa`,
      icon: true,
      description: `Se ha aprobado el servicio por un flete que está por debajo del valor mínimo permitido por el SICETAC`,
      hideBtnCancel: false,
      hideBtnConfirm: true,
    };
    this.dialog.open(DialogComponent, dialogConfig);
  }

  get errorsFieldsCargo(): string[] {
    if (!this.cargo.errorMassiveRequest || !this.cargo.errorFieldsExcelCargo) return [];
    let errors = [];
    const fields = this.cargo.errorFieldsExcelCargo;
    const serviceTypeName = this.cargo.cargoModel.serviceType && this.cargo.cargoModel.serviceType.name ? this.cargo.cargoModel.serviceType.name : null;
    const isEmptyContainer = ['Contenedor vacío con carga de compensación', 'Contenedor vacío express'].includes(serviceTypeName);
    const canBeEmpty = ['cargoMeasureTotal', 'cargoMeasureTotalWeigth', 'cargoMeasureTotalAmount'];
    Object.keys(fields).forEach((key) => {
      if (key === 'origin') {
        const addresses = this.cargo.cargoFeature.uploadDownload.origin.addresses;
        fields.origin.recipientsNames.forEach((name, index) => {
          if (name && this.cargo.ministry && (!addresses || !addresses[index] || !addresses[index].thirdPartyConsignment || !addresses[index].thirdPartyConsignment.document))
            errors.push(`Documento del tercero de la dirección de origen ${index + 1}: ${name}`);
        })
      }
      else if (key === 'destination') {
        const destinations = this.cargo.cargoFeature.uploadDownload.destination;
        fields.destination.forEach((destination, indexD) => {
          const addresses = destinations[indexD].addresses;
          destination.recipientsNames.forEach((name, index) => {
            if (name && this.cargo.ministry && (!addresses || !addresses[index] || !addresses[index].thirdPartyConsignment || !addresses[index].thirdPartyConsignment.document))
              errors.push(`Documento del tercero del destino ${indexD + 1} - dirección ${index + 1}: ${name}`);
          })
        })
      }
      else if (key === 'licensePlate') {
        if (!this.cargo.licensePlate || !this.cargo.driver)
          errors.push(`${[this.global.errorsFieldsExcelDict[key].alias]}: ${fields[key]}`)
      }
      else {
        const cargoValue = this.utils.getNestedValue(this.cargo, this.global.errorsFieldsExcelDict[key].field);
        if (!cargoValue || (cargoValue === 0 && !(isEmptyContainer && canBeEmpty.includes(key))))
          errors.push(`${[this.global.errorsFieldsExcelDict[key].alias]}: ${fields[key]}`)
      }
    })
    return errors;
  }

  get areTravelExpensesPaid(): boolean {
    if (!this.travelExpenses || !this.travelExpenses.length) return false;
    return this.travelExpenses.every(travel => travel && travel.paid);
  }

  get areTravelExpensesApproved(): boolean {
    if (!this.travelExpenses || !this.travelExpenses.length) return false;
    return this.travelExpenses.every(travel => travel && travel.approval === 'Approved');
  }

  get canAddTravelExpenses(): boolean {
    const hasBalanceAndIsPaid = this.utils.getNestedValue(this.cargo, 'shippingCost.balanceState')
      && this.cargoItemService.getCargoBalancePaid(this.cargo) > 0;
    return !hasBalanceAndIsPaid &&
      (this.utils.getNestedValue(this.cargo, 'approval') !== 'Approved' ||
        this.permissionRole.hasPermission(
          this.permission.payments.module,
          this.permission.payments.financialActionsAfterApproval
        ));
  }

  public async showTravelExpensesDialog() {
    const result = await this.cargoManager.preventContinueCargosWithBill([this.cargo]);
    if (!result || !result.continueAnyway) return;
    const config = new MatDialogConfig();
    config.data = {
      cargoId: this.cargo.id,
      cargoConsecutive: this.cargo.consecutive,
      form: {
        travelExpenses: this.travelExpenses
      },
      addEmpty: true
    }
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    this.dialog.open(TravelExpensesComponent, config).afterClosed().subscribe(() => {
      if (!this.isListeningCargoChanges) this.checkTypeOfService(this.cargo.consecutive.toString())
      else this.getTravelExpensesAndUpdateBalance();
    });
  }

  public async showLegalizeTravelExpensesDialog() {
    if (!this.areTravelExpensesApproved) {
      const result = await this.cargoManager.preventContinueCargosWithBill([this.cargo]);
      if (!result || !result.continueAnyway) return;
    }
    const config = new MatDialogConfig();
    config.data = {
      cargo: this.cargo,
      travelExpenses: this.travelExpenses
    }
    config.width = ModalEnum.LARGE_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.maxHeight = ModalEnum.MAX_HEIGHT;

    this.dialog.open(LegalizeTravelExpensesComponent, config).afterClosed().subscribe(() => {
      if (!this.isListeningCargoChanges) this.checkTypeOfService(this.cargo.consecutive.toString())
      else this.getTravelExpensesAndUpdateBalance();
    });
  }

  get showAppUsageDiscount(): boolean {
    return this.authService && this.authService.getCompany() && !!this.authService.getCompany().appUsageDiscountEnabled;
  }

  public get isChargeTaxes(): boolean {
    return this.cargoPaymentsService.isChargeTaxes(this.cargo);
  }
  public get isChargeFopat(): boolean {
    return this.cargoPaymentsService.isChargeFopat(this.cargo);
  }

  private async updateBalance() {
    const cargoWithMergedPayments = this.getCargoWithMergedPayments();
    const balanceState = !!this.utils.getNestedValue(this.cargo, 'shippingCost.balanceState');
    const balance = balanceState
      ? this.cargoItemService.getCargoBalancePaid(cargoWithMergedPayments)
      : await this.cargoPaymentsService.getBalance(cargoWithMergedPayments, true, this.travelExpenses);
    this.balance = balance;
  }

  // TrackBy function para optimizar el rendimiento del ngFor
  public trackByConsignmentField(field: ConsignmentDetailField): string {
    return field && field.label ? field.label : '';
  }

  get canEmitConsignmentRNDC(): boolean {
    if (this.documentRecreationInProgress) return false;
    if (!this.cargo || !this.cargo.ministry) return false;
    if ([CargoStateEnum.REQUEST, this.cargoStateEnum.DELETED, this.cargoStateEnum.EXPIRED].includes(this.cargo.state)) return false;
    const consignments = Object.values(this.cargoConsignments);
    if (!consignments || !consignments.length) return false;
    const permission = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editConsignment);
    return permission && consignments.some(consignment => consignment && !consignment.entryId);
  }

  async reemitConsignmentsToRndc(): Promise<void> {
    if (this.blockDocumentMutation()) return;
    this.spinner.show();
    try {
      await this.cargoTrackingService.emitConsignmentRNDC(this.cargo.id).toPromise();
      await this.getCargoConsignments(this.cargo.id, 'Created');
      // Reload history regardless of retransmission state so the green alert can show the fingerprint
      if (this.cargo.ministry && Object.values(this.cargoConsignments).some(consignment => consignment && consignment.authorizedWithoutConsignment))
        this.loadAuthorizedWithoutConsignmentHistory();
      const consignments = Object.values(this.cargoConsignments);
      if (consignments.some(consignment => consignment && !consignment.entryId))
        this.snackBarService.openSnackBar('No fue posible volver a emitir las remesas al RNDC.', undefined, 'error');
      else
        this.snackBarService.openSnackBar('Remesas reenviadas al RNDC correctamente');
    } catch (e) {
      console.error(e);
      this.snackBarService.openSnackBar('No fue posible volver a emitir las remesas al RNDC.', undefined, 'error');
    }
    this.spinner.hide();
  }

  get canReverseInitialComplitment() {
    const permission = this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.reverseInitialComplitment
    );
    return permission;
  }

  get canEditCargoConsignments(): { canEdit: boolean, reason?: string, description?: string } {
    if (!this.cargo || !this.cargo.ministry) return { canEdit: false, reason: 'No es posible editar remesas', description: 'Contacte a soporte para solucionar este problema' };
    if (!this.cargo.manifestAuthorization) return { canEdit: false, reason: 'No es posible editar remesas', description: 'Debe tener manifiesto autorizado para editar las remesas' };
    if ([CargoStateEnum.REQUEST, this.cargoStateEnum.DELETED, this.cargoStateEnum.EXPIRED].includes(this.cargo.state))
      return { canEdit: false, reason: 'No es posible editar remesas en este estado', description: 'Solo es posible editar remesas de servicios programados, aceptados, en ruta o finalizados' };
    const isFulFilled: boolean = this.cargo.ministryFulfillment;
    if (isFulFilled || (!this.utils.isDefined(isFulFilled) && this.cargo.approval === 'Approved'))
      return { canEdit: false, reason: 'El servicio ya fue cumplido', description: 'Debe reversar el cumplimiento del servicio para editar las remesas' };
    return { canEdit: true };
  }

  get canDeleteOrCreateCargoConsignments(): boolean {
    return !!(this.cargo && this.cargo.ministry && [CargoStateEnum.ACCEPTED, this.cargoStateEnum.CREATED, this.cargoStateEnum.START_SERVICE].includes(this.cargo.state)
      && !this.cargo.manifestAuthorization);
  }

  public goToEditConsignment(consignmentId: string, modificationCode: "1" | "2" | "3" | "4", indexDestination: number, indexAddress: number) {
    if (!this.canEditCargoConsignments.canEdit)
      return this.confirmActionConsignment('edit',
        this.canEditCargoConsignments.reason,
        this.canEditCargoConsignments.description
      );
    if (!this.cargoConsignments[consignmentId])
      return this.confirmActionConsignment('edit',
        'No se encontró la remesa',
        'Contacte a soporte para solucionar este problema'
      );
    if (this.utils.isSameCity(this.cargo))
      return this.confirmActionConsignment('edit',
        'Solo se pueden editar remesas nacionales',
        'Puede anular el manifiesto y volver a crear el servicio'
      );
    if (!modificationCode)
      return this.confirmActionConsignment('edit',
        'No se puede editar la remesa',
        'Contacte a soporte para solucionar este problema'
      );
    const consignment = this.cargoConsignments[consignmentId];
    if (consignment.isDangerous || this.consignmentManager.consignmentHasDangerousNature(consignment))
      return this.confirmActionConsignment('edit',
        'Las remesas de mercancías peligrosas no se pueden editar',
        'Puede anular la remesa y volver a crear el servicio'
      );
    if (consignment.isHazardousWaste || this.consignmentManager.consignmentHasHazardousWaste(consignment))
      return this.confirmActionConsignment('edit',
        'Las remesas de residuos peligrosos no se pueden editar',
        'Puede anular la remesa y volver a crear el servicio'
      );
    if (modificationCode === '1' && Object.keys(this.cargoConsignments).length > 1) {
      return this.confirmActionConsignment('edit',
        'No se puede editar la fecha de cargue de la remesa',
        'Solo se puede editar la fecha de cargue de la remesa cuando el servicio tiene una sola remesa'
      );
    }
    if (this.documentRecreationInProgress)
      return this.confirmActionConsignment('edit',
        DOCUMENT_RECREATION_IN_PROGRESS_TITLE,
        DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE
      );
    this.editConsignment(consignment, modificationCode, indexDestination, indexAddress);
  }

  private confirmActionConsignment(action: 'edit' | 'delete', reason: string, description?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: action === 'edit' ? 'No se puede editar la remesa' : 'No se puede eliminar la remesa',
      descriptionHTML: `
      <p class="text-center text-bold mb-0">${reason}</p>
      <p class="text-center">${description}</p>`,
      hideBtnCancel: true,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  public async editConsignment(consignment: ConsignmentCargo, modificationCode: "1" | "2" | "3" | "4", indexDestination: number, indexAddress: number) {
    const cargoOriginAddress = this.utils.getCargoOriginAddressFromConsignment(this.cargo, consignment);
    if (!cargoOriginAddress || !this.utils.isDefined(cargoOriginAddress.indexAddress))
      return this.confirmActionConsignment('edit',
        'No se encontró la dirección de origen de la remesa',
        'Contacte a soporte para solucionar este problema'
      );
    const { indexAddress: cargoOriginAddressIndex } = cargoOriginAddress;
    const getAdjacentAddressDate = (adjacentAddress: {
      type: 'origin' | 'destination',
      address: AddressCargo,
      destination?: Destination
    }): Date => {
      if (!adjacentAddress || !this.utils.getNestedValue(adjacentAddress, 'address.time')) return null;
      const cityDate = adjacentAddress.type === 'origin'
        ? this.cargo.dateLoad
        : this.utils.getNestedValue(adjacentAddress, 'destination.downloadDate');
      return cityDate
        ? this.utils.getRealDateFromAddress(adjacentAddress.address, cityDate)
        : null;
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    switch (modificationCode) {
      case '1': // Cambiar fecha de cargue
        const loadDate = this.utils.getNestedValue(consignment, 'load.date');
        const loadAppointmentTime = this.utils.getNestedValue(consignment, 'load.appointmentTime');
        const loadDatePart = loadDate.split(' ')[0];
        const loadTimeZone = loadDate.split(' ')[1];
        const loadDateFormatted = DateManager.stringToDate(
          `${loadDatePart} ${loadAppointmentTime} ${loadTimeZone}`,
          'DD/MM/YYYY HH:mm ZZ'
        );
        let fromDate = DateManager.add(loadDateFormatted, 1, 'hours');
        let untilDate = DateManager.add(loadDateFormatted, 1, 'days');
        let fromDateRestriction = '1 hora respecto a la fecha previa de la remesa';
        let untilDateRestriction = '1 día respecto a la fecha previa de la remesa';
        const previousLoadAddress = this.utils.getPreviousAddressCargo(
          this.cargo, 'origin', cargoOriginAddressIndex
        );
        const previousLoadAddressDate = getAdjacentAddressDate(previousLoadAddress);
        if (previousLoadAddressDate && DateManager.isBefore(fromDate, previousLoadAddressDate, 'seconds')) {
          fromDate = previousLoadAddressDate;
          fromDateRestriction = 'la fecha y hora de la dirección previa';
        }
        const nextLoadAddress = this.utils.getNextAddressCargo(
          this.cargo, 'origin', cargoOriginAddressIndex
        );
        const nextLoadAddressDate = getAdjacentAddressDate(nextLoadAddress);
        if (nextLoadAddressDate && DateManager.isBefore(nextLoadAddressDate, untilDate, 'seconds')) {
          untilDate = nextLoadAddressDate;
          untilDateRestriction = 'la fecha y hora de la dirección posterior';
        }
        dialogConfig.data = {
          title: 'Nueva fecha de cargue',
          dateAndTime: true,
          initialDateAndTime: loadDateFormatted,
          fromDate: fromDate,
          untilDate: untilDate,
          descriptionHTML: `
            <div class="alert alert-warning py-2 px-3 mb-3">
              <p class="mb-1"><small><strong>⚠️ Restricciones del RNDC:</strong></small></p>
              <p class="mb-0"><small>La nueva fecha debe ser <strong>posterior a ${DateManager.dateToString(fromDate, 'DD/MM/YYYY HH:mm a')}</strong>
               (${fromDateRestriction}), pero <strong>anterior a ${DateManager.dateToString(untilDate, 'DD/MM/YYYY HH:mm a')}</strong>
               (${untilDateRestriction}).</small></p>
            </div>
          `,
        };
        break;
      case '2': // Cambiar fecha de descargue
        const unloadDate = this.utils.getNestedValue(consignment, 'unload.date');
        const unloadAppointmentTime = this.utils.getNestedValue(consignment, 'unload.appointmentTime');
        const unloadDatePart = unloadDate.split(' ')[0];
        const unloadTimeZone = unloadDate.split(' ')[1];
        const unloadDateFormatted = DateManager.stringToDate(
          `${unloadDatePart} ${unloadAppointmentTime} ${unloadTimeZone}`,
          'DD/MM/YYYY HH:mm ZZ'
        );
        let unloadFromDate = DateManager.add(unloadDateFormatted, 1, 'hours');
        let unloadUntilDate = DateManager.add(unloadDateFormatted, 1, 'days');
        let unloadFromDateRestriction = '1 hora respecto a la fecha previa de la remesa';
        let unloadUntilDateRestriction = '1 día respecto a la fecha previa de la remesa';
        const previousUnloadAddress = this.utils.getPreviousAddressCargo(
          this.cargo, 'destination', indexAddress, indexDestination
        );
        const previousUnloadAddressDate = getAdjacentAddressDate(previousUnloadAddress);
        if (previousUnloadAddressDate && DateManager.isBefore(unloadFromDate, previousUnloadAddressDate, 'seconds')) {
          unloadFromDate = previousUnloadAddressDate;
          unloadFromDateRestriction = 'la fecha y hora de la dirección previa';
        }
        const nextUnloadAddress = this.utils.getNextAddressCargo(
          this.cargo, 'destination', indexAddress, indexDestination
        );
        const nextUnloadAddressDate = getAdjacentAddressDate(nextUnloadAddress);
        if (nextUnloadAddressDate && DateManager.isBefore(nextUnloadAddressDate, unloadUntilDate, 'seconds')) {
          unloadUntilDate = nextUnloadAddressDate;
          unloadUntilDateRestriction = 'la fecha y hora de la dirección posterior';
        }
        dialogConfig.data = {
          title: 'Nueva fecha de descargue',
          dateAndTime: true,
          initialDateAndTime: unloadDateFormatted,
          fromDate: unloadFromDate,
          untilDate: unloadUntilDate,
          descriptionHTML: `
            <div class="alert alert-warning py-2 px-3 mb-3">
              <p class="mb-1"><small><strong>⚠️ Restricciones del RNDC:</strong></small></p>
              <p class="mb-0"><small>La nueva fecha debe ser <strong>posterior a ${DateManager.dateToString(unloadFromDate, 'DD/MM/YYYY HH:mm a')}</strong>
               (${unloadFromDateRestriction}), pero <strong>anterior a ${DateManager.dateToString(unloadUntilDate, 'DD/MM/YYYY HH:mm a')}</strong>
               (${unloadUntilDateRestriction}).</small></p>
            </div>
          `,
        };
        break;
      case '3': // Cambiar dirección de destino
        const consignmentRecipientMunicipalityCode = this.utils.getNestedValue(consignment, 'recipient.municipalityCode');
        const consignmentRecipientDocumentNumber = this.utils.getNestedValue(consignment, 'recipient.documentNumber');
        let listBranchOffices: ThirdPartyAddress[] = [];
        try {
          listBranchOffices = await this.thirdPartyConsignmentService.getThirdPartiesAddressByCompany(consignmentRecipientDocumentNumber, null, null, consignmentRecipientMunicipalityCode).toPromise();
        } catch (error) { }
        if (!listBranchOffices || !listBranchOffices.length)
          return this.snackBarService.openSnackBar('No se encontraron sucursales asociadas al propietario de la remesa en la ciudad de destino', undefined, 'error');
        const listAddresses = [];
        listBranchOffices.forEach((branchOffice, index) => {
          listAddresses.push({
            key: `${index + 1}: ${branchOffice.address.address}`,
            value: {
              branchOffice: branchOffice.address.id,
              documentNumber: branchOffice.information.document,
              documentType: branchOffice.information.documentTypeId,
            }
          });
        });
        dialogConfig.data = {
          title: 'Nueva dirección de destino',
          viewSelect: true,
          listLabel: "Seleccione una dirección de destino",
          list: listAddresses,
          descriptionHTML: `
            <div class="alert alert-warning py-2 px-3 mb-3">
              <p class="mb-1"><small><strong>⚠️ Restricciones del RNDC:</strong></small></p>
              <p class="mb-0"><small>Solo puedes seleccionar una nueva dirección que pertenezca <strong>a la misma ciudad de destino que la remesa actual</strong>.</small></p>
            </div>
          `,
        };
        break;
      case '4': // Cambiar propietario de la remesa
        const cargoOwnerName = this.utils.getNestedValue(this.cargo, 'cargoOwner.name');
        const cargoOwnerBranchOffice = this.utils.getNestedValue(this.cargo, 'cargoOwner.branchOffice');
        dialogConfig.data = {
          title: `¿Deseas actualizar el propietario de la remesa?`,
          descriptionHTML: `
          <p class="text-center">El nuevo propietario de la remesa será <strong>${cargoOwnerName}</strong>, 
          sede <strong>${this.branchOfficeName ? this.branchOfficeName : cargoOwnerBranchOffice}</strong></p>
          `
        };
        break;
    }
    const result = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (!result || !result.state) return;
    const consignmentUpdateRNDC: ConsignmentCargoUpdateRNDC = {
      cargoId: this.cargo.id,
      consecutiveConsignment: consignment.id,
      modificationCode: modificationCode,
      modificationReason: "2",
    };
    switch (modificationCode) {
      case '1':
        consignmentUpdateRNDC.newLoadDate = DateManager.dateToString(result.dateAndTime, 'YYYY-MM-DD');
        consignmentUpdateRNDC.newLoadTime = DateManager.dateToString(result.dateAndTime, 'HH:mm');
        break;
      case '2':
        consignmentUpdateRNDC.newUnloadDate = DateManager.dateToString(result.dateAndTime, 'YYYY-MM-DD');
        consignmentUpdateRNDC.newUnloadTime = DateManager.dateToString(result.dateAndTime, 'HH:mm');
        break;
      case '3':
        consignmentUpdateRNDC.newConsigneeIdType = result.itemSelected.documentType;
        consignmentUpdateRNDC.newConsigneeIdNumber = result.itemSelected.documentNumber;
        consignmentUpdateRNDC.newConsigneeBranchCode = result.itemSelected.branchOffice;
        break;
      case '4':
        consignmentUpdateRNDC.newOwnerBranchCode = this.utils.getNestedValue(this.cargo, 'cargoOwner.branchOffice');
        consignmentUpdateRNDC.newOwnerIdNumber = this.utils.getNestedValue(this.cargo, 'cargoOwner.documentNumber');
        consignmentUpdateRNDC.newOwnerIdType = this.utils.getNestedValue(this.cargo, 'cargoOwner.documentType');
        break;
    }
    await this.updateConsignment(consignmentUpdateRNDC);
  }

  private async updateConsignment(consignment: ConsignmentCargoUpdateRNDC) {
    this.spinner.show();
    try {
      await this.service.updateConsignmentRNDC(consignment).toPromise();
      this.spinner.hide();
      this.snackBarService.openSnackBar(`Remesa ${consignment.consecutiveConsignment} actualizada correctamente`);
    } catch (error) {
      const message = this.utils.getNestedValue(error, 'error.message');
      this.spinner.hide();
      this.snackBarService.openSnackBar(message ? message : "Ocurrió un error al actualizar la remesa", undefined, "error");
    }
    this.checkTypeOfService(this.cargo.consecutive.toString());
  }

  public async confirmDeleteConsignment(consignmentId: string) {
    if (this.blockDocumentMutation()) return;
    if (!this.utils.isEmpty(this.cargo.manifestAuthorization))
      return this.confirmActionConsignment('delete',
        'Las remesas con manifiesto generado no se pueden editar',
        'Puede anular el manifiesto y volver a crear el servicio'
      );
    const consignment = this.cargoConsignments[consignmentId];
    if (!consignment)
      return this.confirmActionConsignment('delete',
        'No se encontró la remesa',
        'Contacte a soporte para solucionar este problema'
      );
    const result = await this.cargoManager.openDialogConfirm(`¿Estás seguro que deseas eliminar la remesa ${consignment.id}?`);
    if (!result || !result.confirm) return;
    if (this.blockDocumentMutation()) return;
    this.spinner.show();
    let success = null;
    try {
      success = await this.service.deleteConsignment(consignment.documentId, this.cargo.id).toPromise();
      this.spinner.hide();
      this.snackBarService.openSnackBar("Remesa anulada correctamente");
      this.checkTypeOfService(this.cargo.consecutive.toString());
    } catch (error) {
      this.spinner.hide();
      this.snackBarService.openSnackBar("Ocurrió un error al anular la remesa", undefined, "error");
    }
  }

  public async generateNewConsignment() {
    if (this.blockDocumentMutation()) return;
    const dialogConfig = new MatDialogConfig();
    const previousConsignments = this.cargoConsignments && Object.keys(this.cargoConsignments).length ? Object.values(this.cargoConsignments) : [];
    dialogConfig.data = {
      cargo: this.cargo,
      previousConsignments: previousConsignments
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const response = await this.dialog.open(ConsignmentFormComponent, dialogConfig).afterClosed().toPromise();
    if (response && response.state)
      this.checkTypeOfService(this.cargo.consecutive.toString());

  }

  get canOpenDialogGuides() {
    const hasPermission = this.permissionRole.hasPermission(this.permission.guide.module, this.permission.guide.trackGuide);
    const downloads: Destination[] = this.utils.getNestedValue(this.cargo, 'cargoFeature.uploadDownload.destination');
    return hasPermission && downloads && downloads.some(download => download && download.addresses && download.addresses.some(address =>
      !!(address && address.guidesId && address.guidesId.length))
    );
  }

  openDialogGuides() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { cargo: this.cargo };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(CargoGuidesListComponent, dialogConfig);
  }

  get minimumApprovedValueSicetacFormatted() {
    return this.cargo && this.cargo.minimumApprovedValueSicetac ? this.formatter.format(this.cargo.minimumApprovedValueSicetac) : this.formatter.format(0);
  }

  getCostNotAllowed(serviceCost: number): boolean {
    return this.cargo && this.cargo.minimumApprovedValueSicetac && serviceCost && (serviceCost < this.cargo.minimumApprovedValueSicetac);
  }

  hasSameConsignmentDates(cargoDate: string, consignmentDate: string): boolean {
    if (!cargoDate || !consignmentDate) return false;
    const cargoDateFormatted = DateManager.stringToDate(cargoDate);
    const consignmentDateFormatted = DateManager.stringToDate(consignmentDate, 'DD/MM/YYYY');
    return DateManager.isSame(cargoDateFormatted, consignmentDateFormatted, 'days');
  }

  getTitleAddressCargoDurationTime(addressType: 'origin' | 'destination', type: 'start' | 'end'): string {
    const titleOtherService = {
      origin: {
        start: 'Llegada al origen',
        end: 'Salida del origen'
      },
      destination: {
        start: 'Llegada al destino',
        end: 'Salida del destino'
      }
    };
    const titleTransportService = {
      origin: {
        start: 'Inicio de cargue',
        end: 'Finalización de cargue'
      },
      destination: {
        start: 'Inicio de descargue',
        end: 'Finalización de descargue'
      }
    };
    return this.isTransportService ? titleTransportService[addressType][type] : titleOtherService[addressType][type];
  }

  get canEditAddressCargoDurationTime(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editAddressCargoDurationTime)
      && !['Approved', 'Rejected'].includes(this.cargo.approval);
  }

  public async editAddressCargoDurationTime(address: AddressCargo, addressType: 'origin' | 'destination', type: 'start' | 'end', indexAddress: number, indexDownload?: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Nueva fecha de ${this.getTitleAddressCargoDurationTime(addressType, type).toLowerCase()}`,
      dateAndTime: true,
      initialDateAndTime: type === 'start'
        ? DateManager.stringToDate(address.durationTime.startDate)
        : DateManager.stringToDate(address.durationTime.endDate)
    };
    let descriptionHTML = `<p class="text-bold text-center">Ingrese la fecha para la dirección ${address.address}</p>`;
    let fromDate = null;
    let untilDate = new Date();
    if (type === 'end') {
      fromDate = DateManager.stringToDate(address.durationTime.startDate);
      const nextAddress = this.utils.getNextAddressCargo(this.cargo, addressType, indexAddress, indexDownload);
      const nextAddressStartDate = this.utils.getNestedValue(nextAddress, 'address.durationTime.startDate');
      if (nextAddressStartDate) untilDate = DateManager.stringToDate(nextAddressStartDate);
    } else {
      const previousAddress = this.utils.getPreviousAddressCargo(this.cargo, addressType, indexAddress, indexDownload);
      const previousAddressEndDate = this.utils.getNestedValue(previousAddress, 'address.durationTime.endDate');
      if (previousAddressEndDate) fromDate = DateManager.stringToDate(previousAddressEndDate);
      if (address.durationTime.endDate) untilDate = DateManager.stringToDate(address.durationTime.endDate);
    }
    if (fromDate) descriptionHTML += `<p class="text-center mb-0">Debe ser posterior a: ${DateManager.dateToString(fromDate, 'DD/MM/YYYY HH:mm a')}</p>`;
    if (untilDate) descriptionHTML += `<p class="text-center mb-0">Debe ser anterior a: ${DateManager.dateToString(untilDate, 'DD/MM/YYYY HH:mm a')}</p>`;
    dialogConfig.data.descriptionHTML = descriptionHTML;
    dialogConfig.data.fromDate = fromDate;
    dialogConfig.data.untilDate = untilDate;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const result = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (!result || !result.state) return;
    const newDate: Date = result.dateAndTime;
    if (DateManager.utcTransform(newDate) === address.durationTime[type === 'start' ? 'startDate' : 'endDate'])
      return this.snackBarService.openSnackBar('La fecha ingresada es la misma que la actual', undefined, 'alert');
    const endDate = this.utils.getNestedValue(address, 'durationTime.endDate');
    const newStartDate = type === 'start' ? newDate : DateManager.stringToDate(address.durationTime.startDate);
    const newEndDate = type === 'end' ? newDate : endDate ? DateManager.stringToDate(endDate) : null;
    const newDuration = endDate ? DateManager.dateDiff(newEndDate, null, newStartDate, null, 'milliseconds') : null;
    const logisticTime: LogisticTime = {
      scope: addressType,
      addressId: indexAddress.toString(),
      destinationId: this.utils.isDefined(indexDownload) ? indexDownload.toString() : null,
      durationTime: {
        startDate: DateManager.dateToString(newStartDate),
        startDateSource: type === 'start' ? 'manual' : this.utils.getNestedValue(address, 'durationTime.startDateSource'),
        endDate: DateManager.dateToString(newEndDate),
        endDateSource: type === 'end' ? 'manual' : this.utils.getNestedValue(address, 'durationTime.endDateSource'),
        duration: newDuration
      }
    }
    await this.updateCargoLogisticTimes(logisticTime);
    if (!this.isListeningCargoChanges)
      this.getCargoDetailById(this.cargo.consecutive.toString());
  }

  private async updateCargoLogisticTimes(logisticTime: LogisticTime) {
    this.spinner.show();
    let response: LogisticTime;
    try { response = await this.service.updateCargoLogisticTimes(this.cargo.id, logisticTime).toPromise() } catch (error) { }
    this.spinner.hide();
    if (!response) return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    this.snackBarService.openSnackBar('Fecha actualizada correctamente');
    this.getCargoDetailById(this.cargo.consecutive.toString());
  }

  private async buildHistoryCargoLogisticTimes() {
    const logisticTimes = await this.getCargoLogisticTimes();
    this.historyCargoLogisticTimes = { origin: {}, destination: {} };
    const sortedLogisticTimes = logisticTimes.sort((a, b) => {
      const dateA = a.fingerprint && a.fingerprint.date ? DateManager.stringToDate(a.fingerprint.date) : null;
      const dateB = b.fingerprint && b.fingerprint.date ? DateManager.stringToDate(b.fingerprint.date) : null;
      if (!dateA && !dateB) {
        const dateADuration = this.utils.getNestedValue(a, 'durationTime.endDate');
        const dateBDuration = this.utils.getNestedValue(b, 'durationTime.endDate');
        if (!dateADuration && !dateBDuration) return 0;
        if (!dateADuration) return -1;
        if (!dateBDuration) return 1;
        return 0;
      }
      if (!dateA) return -1;
      if (!dateB) return 1;
      return DateManager.isBefore(dateA, dateB, 'seconds') ? -1 : 1;
    });

    sortedLogisticTimes.forEach(logisticTime => {
      if (['scope', 'addressId'].some(key => !logisticTime[key])) return;
      const scope = logisticTime.scope.toLowerCase();
      const isOrigin = scope === 'origin';
      if (isOrigin)
        this.processOriginLogisticTime(logisticTime);
      else if (logisticTime.destinationId)
        this.processDestinationLogisticTime(logisticTime);
    });

  }

  private processOriginLogisticTime(logisticTime: LogisticTime) {
    const addressId = logisticTime.addressId;
    if (!this.historyCargoLogisticTimes.origin[addressId])
      this.historyCargoLogisticTimes.origin[addressId] = { startDate: [], endDate: [] };

    const existingTimes = this.historyCargoLogisticTimes.origin[addressId];
    const lastTimeStart: LogisticTime = existingTimes.startDate[existingTimes.startDate.length - 1];
    const lastTimeEnd: LogisticTime = existingTimes.endDate[existingTimes.endDate.length - 1];
    const lastStartDate = this.utils.getNestedValue(lastTimeStart, 'durationTime.startDate');
    const lastEndDate = this.utils.getNestedValue(lastTimeEnd, 'durationTime.endDate');
    const logisticTimeStartDate = this.utils.getNestedValue(logisticTime, 'durationTime.startDate');
    const logisticTimeFingerprint = this.utils.getNestedValue(logisticTime, 'fingerprint');
    const logisticTimeEndDate = this.utils.getNestedValue(logisticTime, 'durationTime.endDate');

    if (!lastTimeStart && logisticTimeStartDate)
      this.historyCargoLogisticTimes.origin[addressId].startDate.push(logisticTime);
    if (!lastTimeEnd && logisticTimeEndDate)
      this.historyCargoLogisticTimes.origin[addressId].endDate.push(logisticTime);
    if (lastStartDate && logisticTimeStartDate && lastStartDate !== logisticTimeStartDate && logisticTimeFingerprint)
      this.historyCargoLogisticTimes.origin[addressId].startDate.push(logisticTime);
    if (lastEndDate && logisticTimeEndDate && lastEndDate !== logisticTimeEndDate && logisticTimeFingerprint)
      this.historyCargoLogisticTimes.origin[addressId].endDate.push(logisticTime);
  }

  private processDestinationLogisticTime(logisticTime: LogisticTime) {
    const destinationId = logisticTime.destinationId;
    const addressId = logisticTime.addressId;
    if (!this.historyCargoLogisticTimes.destination[destinationId])
      this.historyCargoLogisticTimes.destination[destinationId] = {};
    if (!this.historyCargoLogisticTimes.destination[destinationId][addressId])
      this.historyCargoLogisticTimes.destination[destinationId][addressId] = { startDate: [], endDate: [] };

    const existingTimes = this.historyCargoLogisticTimes.destination[destinationId][addressId];
    const lastTimeStart: LogisticTime = existingTimes.startDate[existingTimes.startDate.length - 1];
    const lastTimeEnd: LogisticTime = existingTimes.endDate[existingTimes.endDate.length - 1];
    const lastStartDate = this.utils.getNestedValue(lastTimeStart, 'durationTime.startDate');
    const lastEndDate = this.utils.getNestedValue(lastTimeEnd, 'durationTime.endDate');
    const logisticTimeStartDate = this.utils.getNestedValue(logisticTime, 'durationTime.startDate');
    const logisticTimeFingerprint = this.utils.getNestedValue(logisticTime, 'fingerprint');
    const logisticTimeEndDate = this.utils.getNestedValue(logisticTime, 'durationTime.endDate');

    if (!lastTimeStart && logisticTimeStartDate)
      this.historyCargoLogisticTimes.destination[destinationId][addressId].startDate.push(logisticTime);
    if (!lastTimeEnd && logisticTimeEndDate)
      this.historyCargoLogisticTimes.destination[destinationId][addressId].endDate.push(logisticTime);
    if (lastStartDate && logisticTimeStartDate && lastStartDate !== logisticTimeStartDate && logisticTimeFingerprint)
      this.historyCargoLogisticTimes.destination[destinationId][addressId].startDate.push(logisticTime);
    if (lastEndDate && logisticTimeEndDate && lastEndDate !== logisticTimeEndDate && logisticTimeFingerprint)
      this.historyCargoLogisticTimes.destination[destinationId][addressId].endDate.push(logisticTime);
  }

  private async getCargoLogisticTimes() {
    let response: LogisticTime[] = [];
    try { response = await this.service.getCargoLogisticTimes(this.cargo.id).toPromise() } catch (error) { }
    return response && response.length ? response : [];
  }

  public canOpenHistoryCargoLogisticTimes(addressType: 'origin' | 'destination', type: 'startDate' | 'endDate', indexAddress: number, indexDownload?: number): { canOpen: boolean, history: LogisticTime[] } {
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editAddressCargoDurationTime))
      return { canOpen: false, history: [] };
    let history: LogisticTime[] = null;
    if (addressType === 'origin')
      history = this.utils.getNestedValue(this.historyCargoLogisticTimes, `origin.${indexAddress}.${type}`);
    else
      history = this.utils.getNestedValue(this.historyCargoLogisticTimes, `destination.${indexDownload}.${indexAddress}.${type}`);
    return { canOpen: !!(history && history.length && history.length > 1 && history.some(logisticTime => !!logisticTime.fingerprint)), history };
  }

  public getFingerprintDescriptionByAddress(address: AddressCargo, addressType: 'origin' | 'destination', type: 'startDate' | 'endDate', indexAddress: number, indexDownload?: number): string {
    const { canOpen, history } = this.canOpenHistoryCargoLogisticTimes(addressType, type, indexAddress, indexDownload);
    if (canOpen) return '';
    if (!history || !history.length) return '';
    const lastHistory = history[0];
    const fingerprint = this.utils.getNestedValue(lastHistory, 'fingerprint');
    if (!fingerprint || !fingerprint.date || !fingerprint.userName || !fingerprint.userId) return '';
    const fingerprintDate = DateManager.stringToDate(fingerprint.date);
    const addressDate = DateManager.stringToDate(this.utils.getNestedValue(address, `durationTime.${type}`));
    if (!fingerprintDate || !addressDate || !DateManager.isSame(fingerprintDate, addressDate, 'seconds')) return '';
    return `Registrado por: ${fingerprint.userName} (${fingerprint.userId})\nFecha: ${this.dateFormatPipe.transform(fingerprint.date, 'only-date')} ${this.dateFormatPipe.transform(fingerprint.date, 'time')}`;
  }

  public openHistoryCargoLogisticTimes(address: AddressCargo, addressType: 'origin' | 'destination', type: 'startDate' | 'endDate', indexAddress: number, indexDownload?: number) {
    const { canOpen, history } = this.canOpenHistoryCargoLogisticTimes(addressType, type, indexAddress, indexDownload);
    if (!canOpen) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Historial de cambios',
      descriptionHTML: `<small class="my-4">A continuación se muestra el historial de cambios de los tiempos registrados, ordenados desde el más antiguo hasta el más reciente.</small>`,
      hideBtnConfirm: true,
    };
    dialogConfig.data.descriptionHTML += `<p class="my-4"><b class="text-bold">Dirección:</b> ${address.address}</p>`;
    const formatDate = (date: string) => DateManager.formatDate(date, 'YYYY-MM-DD HH:mm ZZ', 'DD/MM/YYYY HH:mm a');
    [...history].forEach((logisticTime, index) => {
      const title = logisticTime.fingerprint && !!index ? `${index}° Cambio` :
        this.getTitleAddressCargoDurationTime(addressType, type === 'startDate' ? 'start' : 'end');
      const responsible = this.utils.getNestedValue(logisticTime, 'fingerprint.userName');
      const responsibleDocument = this.utils.getNestedValue(logisticTime, 'fingerprint.userId');
      const responsibleDate = this.utils.getNestedValue(logisticTime, 'fingerprint.date');
      const eventTitle = this.getTitleAddressCargoDurationTime(addressType, type === 'startDate' ? 'start' : 'end');
      dialogConfig.data.descriptionHTML += `
        <div class="mt-2">
          <div class="alert alert-info p-2 px-4 mb-2 d-flex justify-content-between flex-wrap">
            <div class="text-bold">${title}</div>
            <div>${responsibleDate && !!index ? formatDate(responsibleDate) : ''}</div>
          </div>
          <div class="pl-3 mb-2 d-flex flex-column">
            <div class="col-12"><strong class="text-bold">${eventTitle}:</strong> ${formatDate(logisticTime.durationTime[type])}</div>
            ${responsible ? `<div class="col-12"><strong class="text-bold">Responsable:</strong> ${responsible}${responsibleDocument ? ` (${responsibleDocument})` : ''}</div>` : ''}
            </div>
          </div>
        </div>
      `;
    });
    dialogConfig.data.descriptionHTML += '<div class="mb-5"></div>';
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  get totalAmountDelivered(): number {
    if (!this.cargo) return 0;
    if (!this.cargo.ministry || !this.cargo.requiresMinistryLogisticTimes)
      return this.utils.getNestedValue(this.cargo, 'cargoFeature.cargoMeasure.amountDelivered') || 0;
    const destinations: Destination[] = this.utils.getNestedValue(this.cargo, 'cargoFeature.uploadDownload.destination');
    if (!destinations || !destinations.length) return 0;
    return destinations.reduce((total, destination) => {
      if (destination.addresses && destination.addresses.length) {
        return total + (destination.addresses.reduce((total, address) => {
          return total + (this.utils.getNestedValue(address, 'cargoMeasure.amountDelivered') || 0);
        }, 0));
      }
    }, 0);
  }


  canEditSections(section: string): boolean {
    if (!this.cargo) return false;
    if (['contractorInformation', 'contractorAdditionalInformation', 'cargoCharacteristics'].includes(section))
      return [CargoStateEnum.ACCEPTED, CargoStateEnum.CREATED, CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE].includes(this.cargo.state)
    return [CargoStateEnum.ACCEPTED, CargoStateEnum.CREATED, CargoStateEnum.START_SERVICE].includes(this.cargo.state)
  }

  async editSection(section: string) {
    if (section === 'manifest' && this.blockDocumentMutation()) return;
    if (section === 'contractorInformation' && this.utils.isDefined(this.cargo.consecutiveMainCargo))
      return this.snackBarService.openSnackBar(
        ServiceMessages.CONSOLIDATED_CARGO_CONTRACTOR_NOT_EDITABLE,
        undefined,
        'error'
      );
    if (section === 'contractorInformation' && isContractorTransportEditionBlockedByBilling(this.cargo))
      return this.snackBarService.openSnackBar(
        'No se puede editar el contratante ni la empresa de transporte porque el servicio ya está facturado/prefacturado.',
        undefined,
        'error'
      );
    const sections = this.serviceValidationManager.getSectionsWithValidation(this.cargo, this.vehicle, this.cargoConsignments ? Object.values(this.cargoConsignments) : []);
    if (!sections[section])
      return this.snackBarService.openSnackBar(`No es posible editar la sección`, undefined, 'error');
    for (const canEdit of sections[section].canEdit) {
      if (!canEdit.restriction)
        return this.snackBarService.openSnackBar(canEdit.message, undefined, 'error');
    }
    this.spinner.show();
    let cargo: Cargo;
    try { cargo = await this.service.detailCargoByConsecutive(this.cargo.consecutive.toString()).toPromise() } catch (error) { }
    this.spinner.hide();
    if (!cargo) return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    if (this.isNecessaryToRedirect(cargo)) return;
    if (section === 'manifest' && isDocumentRecreationInProgress(cargo))
      return this.snackBarService.openSnackBar(
        this.documentRecreationInProgressMessage,
        undefined,
        'alert'
      );
    if (section === 'contractorInformation' && isContractorTransportEditionBlockedByBilling(cargo))
      return this.snackBarService.openSnackBar(
        'No se puede editar el contratante ni la empresa de transporte porque el servicio ya está facturado/prefacturado.',
        undefined,
        'error'
      );
    this.setLoadData(cargo);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: cargo,
      ...(sections[section].dialogData || {})
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialogSectionRef = this.dialog.open(sections[section].component, dialogConfig);
    this.dialogSectionRef.afterClosed().subscribe(result => {
      this.dialogSectionRef = null;
      if (result && result.state) {
        this.getCargoDetailById(this.cargo.consecutive.toString());
      }
    });
  }

  get documentRecreationInProgress(): boolean {
    return isDocumentRecreationInProgress(this.cargo);
  }

  private blockDocumentMutation(): boolean {
    if (!this.documentRecreationInProgress) return false;
    this.snackBarService.openSnackBar(
      this.documentRecreationInProgressMessage,
      undefined,
      'alert'
    );
    return true;
  }

  async editFingerPrintUser(title: string, field: string, initialValue: {
    name: string,
    document: string
  }) {
    const dialogConfig = new MatDialogConfig();
    const options = {
      title: 'Responsable',
      filterBy: 'userClient',
      appearance: 'outline'
    };
    dialogConfig.data = {
      title,
      description: `Por favor seleccione el nuevo responsable ${initialValue && initialValue.name
        ? 'que reemplazará a ' + initialValue.name : ''} ${initialValue && initialValue.document ? '(' + initialValue.document + ')'
          : ''}`,
      inputDocumentUser: true,
      optionsDocumentUser: options
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialogFingerprintRef = this.dialog.open(DialogComponent, dialogConfig);
    const response = await this.dialogFingerprintRef.afterClosed().toPromise();
    if (this.dialogFingerprintRef) this.dialogFingerprintRef = null;
    if (!response || !response.state || !response.inputDocumentUser) return;
    this.updateCargoFingerPrint(field, response.inputDocumentUser);
  }

  private async updateCargoFingerPrint(field: string, user: User) {
    this.spinner.show();
    let cargo: Cargo;
    try { cargo = await this.service.detailCargoByConsecutive(this.cargo.consecutive.toString()).toPromise() } catch (error) { }
    if (!cargo) {
      this.spinner.hide();
      return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    }
    if (field === 'numberDocumentCreatorLoad') {
      cargo['numberDocumentCreatorLoad'] = user.information.document;
      this.cargoCreator = null;
    } else if (field === 'approvalUserId') {
      cargo['approvalUserId'] = user.information.document;
      cargo['approvalUserName'] = user.information.name;
    } else if (field === 'prevalidationFingerprint') {
      cargo.prevalidation.fingerprint['userId'] = user.information.document;
      cargo.prevalidation.fingerprint['userName'] = user.information.name;
    } else {
      //assignedVehicleFingerPrint, confirmedDriverFingerprint, finishedByFingerprint
      cargo[field].userId = user.information.document;
      cargo[field].userName = user.information.name;
    }
    delete cargo.shippingCost.payments;
    delete cargo.travelExpenses;
    delete cargo.validatedBankAccount;
    try { await this.menuService.updateOnlyRequest(cargo).toPromise() }
    catch (error) {
      this.spinner.hide();
      return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    }
    this.snackBarService.openSnackBar('Responsable actualizado correctamente');
    this.spinner.hide();
    if (!this.isListeningCargoChanges)
      this.getCargoDetailById(this.cargo.consecutive.toString());
  }

  public get canSeeStateDispatch(): boolean {
    if (!this.cargo) return false;
    if (this.cargo.confirmedDriver) return false;
    if (![this.cargoStateEnum.ACCEPTED, this.cargoStateEnum.CREATED, this.cargoStateEnum.REQUEST].includes(this.cargo.state)) return false;
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.panelAssignments)) return false;
    return true;
  }

  public get canSeeConsecutiveMainCargo(): boolean {
    if (!this.cargo) return false;
    if (!this.isRootNit) return false;
    return !!this.cargo.consecutiveMainCargo;
  }

  public get requiresPreValidation(): boolean {
    return this.authService && this.authService.hasCompanySettingEnabled(SettingId.REQUIRES_PRE_VALIDATION);
  }

  public canValidateCargo(validate: boolean): boolean {
    if (!this.cargo) return false;
    if (!this.requiresPreValidation) return false;
    if (this.cargo.shippingCost && this.cargo.shippingCost.cashed) return false;
    if (this.cargo.preBill) return false;
    if (![CargoStateEnum.END_SERVICE, CargoStateEnum.START_SERVICE].includes(this.cargo.state)) return false;
    const prevalidationValid: boolean = this.utils.getNestedValue(this.cargo, 'prevalidation.valid');
    if (validate) {
      if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.validateCargo)) return false;
      return !prevalidationValid;
    }
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.reverseValidateCargo)) return false;
    return prevalidationValid;
  }

  public async validateService(): Promise<void> {
    const { confirm } = await this.cargoManager.openDialogConfirm(
      "¿Está seguro de que desea validar el servicio?",
      "Al validar el servicio se confirma que la información financiera es correcta y se puede realizar la facturación.")
    if (!confirm) return;
    this.spinner.show();
    try {
      await this.service.updatePrevalidation(this.cargo.id, { valid: true }).toPromise();
      this.snackBarService.openSnackBar('Servicio validado correctamente');
      if (!this.isListeningCargoChanges)
        this.checkTypeOfService(this.cargo.consecutive.toString());
    } catch (error) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    } finally {
      this.spinner.hide();
    }
  }

  public async reverseValidation(): Promise<void> {
    const { confirm, description } = await this.cargoManager.openDialogConfirmWithDescription(
      "¿Está seguro de que desea revertir la validación del servicio?", "Motivo de la reversión", 50, 8);
    if (!confirm) return;
    this.spinner.show();
    try {
      await this.service.updatePrevalidation(this.cargo.id, { valid: false, observation: description }).toPromise();
      this.snackBarService.openSnackBar('Validación revertida correctamente');
      if (!this.isListeningCargoChanges)
        this.checkTypeOfService(this.cargo.consecutive.toString());
    } catch (error) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    } finally {
      this.spinner.hide();
    }
  }

  public get canEditRequiresPreBill(): boolean {
    if (!this.cargo) return false;
    if (this.cargo.preBill) return false;
    if (this.cargo.shippingCost && this.cargo.shippingCost.cashed) return false;
    if (![CargoStateEnum.CREATED, CargoStateEnum.ACCEPTED, CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE].includes(this.cargo.state))
      return false;
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.showEditFinancialInformationModule);
  }

  public async updateRequiresPreBill(requiresPreBill: boolean): Promise<void> {
    const { confirm } = await this.cargoManager.openDialogConfirm(`¿Este servicio ${requiresPreBill ? 'requiere' : 'no requiere'} pre-factura?`,
      requiresPreBill ?
        `Si activa el requerimiento de pre-factura, se requerirá que el servicio esté asociado a una prefactura antes de poder facturar.` :
        `Si desactiva el requerimiento de pre-factura, se podrá facturar el servicio sin asociarlo a una prefactura.`
    );
    if (!confirm) return;
    this.spinner.show();
    const body = {
      id: this.cargo.id,
      requiresPreBill: requiresPreBill
    };
    ["isSecondDriverActive", "uploadedBillingXML", "simpleRegimen"].forEach(key => {
      if (this.utils.isDefined(this.cargo[key]))
        body[key] = this.cargo[key];
    });
    try {
      await this.service.updateCargo(body).toPromise();
      this.snackBarService.openSnackBar('Requerimiento de pre-factura actualizado correctamente');
    } catch (error) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    } finally {
      this.spinner.hide();
    }
  }

  public get canSeeSectionErrors(): boolean {
    if (!this.cargo) return false;
    if (!this.isRootNit) return false;
    return [this.cargoStateEnum.ACCEPTED, this.cargoStateEnum.CREATED, this.cargoStateEnum.REQUEST].includes(this.cargo.state);
  }

  private loadSectionErrors() {
    if (!this.cargo) return;
    const sections = this.serviceValidationManager.getSectionsWithValidation(this.cargo, this.vehicle, this.cargoConsignments ? Object.values(this.cargoConsignments) : [], true);

    Object.keys(sections).forEach(key => {
      const section = sections[key];
      if (!section.checkValid.isValid) {
        this.errorsBySection[key] = section.checkValid.error;
      }
    });
  }
}
